export const ar = {


  "translation": {
    "vacationContent": {"title":"عنوان الإعلان","description":"الوصف"},
"desktopHome": {"mapTitle":"اكتشف عقارات في جميع أنحاء تونس","mapUnavailable":"الخريطة غير متاحة مؤقتًا.","verified":"إعلانات تم التحقق منها","verifiedText":"إعلانات مراقبة لمزيد من الثقة.","everywhere":"في جميع أنحاء تونس","everywhereText":"عقارات في جميع الولايات.","simple":"بسيط وسريع","simpleText":"اعثر على عقارك ببضع نقرات.","support":"فريق يستمع إليك","supportText":"مرافقة شخصية في كل خطوة."},
"vacationPublication": {"optionalPrice":"السعر لليلة (اختياري)","invalidPrice":"أدخل سعرًا موجبًا صالحًا أو اترك الحقل فارغًا.","noPrice":"السعر غير محدد","contactForPrice":"اتصل بصاحب الإعلان لمعرفة السعر قبل الحجز.","imageLimit":"يمكنك إضافة {{count}} صورة كحد أقصى.","imageCount":"{{count}} / {{max}} صور"},
    "mobileFinal": {"reset":"إعادة ضبط","apply":"عرض النتائج","searchPlaceholder":"مدينة، حي أو كلمة مفتاحية","aiIntro":"صف ما تبحث عنه وسأتولى الباقي","aiExample":"مثال: غرفتان في سوسة، 250 ألف دينار","longStay":"بيع أو إيجار طويل المدى","publishVacation":"نشر إيجار للعطلات","shortStay":"إيجار يومي أو للعطلات"},
    "phoneNav": {"navigation":"التنقل الرئيسي","favorites":"المفضلة","publish":"أعلن","profile":"حسابي","menu":"القائمة","sale":"للبيع","rent":"للكراء","vacation":"العطلات","requests":"طلبات عقارية"},
    "homeDestinations": { "sidiBouSaid": "سيدي بوسعيد" },
    "voice": {"start":"إملاء صوتي","stop":"إيقاف الإملاء","listening":"أستمع إليك…","denied":"الميكروفون غير مسموح به. يمكنك الكتابة بلوحة المفاتيح.","noSpeech":"لم أسمع شيئاً. حاول مجدداً.","error":"لم ينجح الإملاء الصوتي. يمكنك الكتابة بلوحة المفاتيح."},
    "propertyRequest": {"notify":{"proposal":"تم استلام اقتراح جديد لأحد طلبات البحث الخاصة بك."},"nav":{"public":"طلبات البحث عن عقار","mine":"طلبات بحثي","new":"جديد"},"home":{"title":"لم تجد العقار المناسب؟","lead":"صف ما تبحث عنه، ويمكن للمعلنين أن يقترحوا عليك عقاراتهم.","start":"أبحث عن عقار","browse":"عرض طلبات البحث","resume":"استئناف بحثي"},"new":{"title":"أبحث عن عقار","subtitle":"صف ما تبحث عنه، وتساعدك لينا إيمو على إيجاد الإعلانات المناسبة.","draftRestored":"تمت استعادة بحثك الجاري.","restart":"البدء من جديد","continue":"متابعة"},"text":{"label":"صف ما تبحث عنه","placeholder":"أبحث عن أرض مساحتها من 200 إلى 300 م² في سهلول، بميزانية أقصاها 250 000 د.ت.","notice":"النص الحر يظهر للمعلنين، لكن بعض المعايير المذكورة في النص فقط قد لا تُستعمل في الترتيب.","noContact":"لا تكتب بريدًا إلكترونيًا أو رقم هاتف في هذا النص: سيتم إخفاؤهما.","count":"{{count}} / {{max}}"},"criteria":{"title":"المعايير","required":"إلزامي","transaction":"نوع المعاملة","categories":"نوع العقار","city":"الولاية","chooseCity":"اختر الولاية","delegations":"المعتمديات","delegationsHint":"اختياري، حتى {{max}}. دون معتمدية: كامل الولاية.","addDelegation":"إضافة معتمدية","removeDelegation":"حذف {{name}}","chooseCityFirst":"اختر الولاية أولًا.","budgetMin":"الميزانية الدنيا ({{unit}})","budgetMax":"الميزانية القصوى ({{unit}})","surfaceMin":"المساحة الدنيا (م²)","surfaceMax":"المساحة القصوى (م²)","min":"الأدنى","max":"الأقصى","more":"الغرف والتجهيزات","bedroomsMin":"عدد الغرف (الحد الأدنى)","attributes":"التجهيزات","landNote":"الأرض ليس لها غرف ولا تجهيزات.","chooseTypeFirst":"اختر نوع العقار أولًا."},"transaction":{"sale":"شراء","rent":"كراء","vacation":"كراء للعطلة"},"transactionShort":{"sale":"شراء","rent":"كراء","vacation":"عطلة"},"attribute":{"parking":"مأوى سيارة","furnished":"مفروش","kitchen":"مطبخ","ac":"مكيف","pool":"مسبح","garden":"حديقة","barbecue":"شواء","beachAccess":"قرب الشاطئ","workspace":"مكان للعمل","washer":"غسالة","wifi":"واي فاي","tv":"تلفاز","elevator":"مصعد","balcony":"شرفة أو سطح","seaView":"إطلالة على البحر"},"budgetUnit":{"sale":"د.ت","rent":"د.ت / شهر","vacation":"د.ت / ليلة"},"preview":{"title":"تحقق من بحثك","subtitle":"لا يُنشر أي شيء في هذه المرحلة. صحّح ما لا يناسبك.","text":"نصّك","summary":"أنت تبحث عن:","edit":"تعديل","publish":"نشر بحثي","publishing":"جارٍ النشر…","signInTitle":"يجب تسجيل الدخول للنشر","signInText":"تبقى معاييرك محفوظة في هذه النافذة أثناء تسجيل الدخول. ارجع بعد ذلك عبر «استئناف بحثي».","signIn":"تسجيل الدخول","signUp":"إنشاء حساب","lifetime":"يبقى بحثك منشورًا 30 يومًا. يمكنك تعديله أو إغلاقه من «طلبات بحثي»."},"summary":{"transaction":"نوع المعاملة","categories":"نوع العقار","location":"الموقع","wholeCity":"{{city}} (كامل الولاية)","budget":"الميزانية","surface":"المساحة","bedrooms":"الغرف","attributes":"التجهيزات","text":"النص الحر","contact":"التواصل","none":"غير محدد","min":"على الأقل {{value}}","max":"على الأكثر {{value}}","between":"{{min}} – {{max}}","bedroomsValue":"{{count}} على الأقل"},"contact":{"title":"كيف نتواصل معك؟","email":"البريد الإلكتروني","phone":"الهاتف","both":"الاثنان","prefilled":"مُعبّأ من حسابك","privacy":"لا يُعرض بريدك الإلكتروني ولا هاتفك للعموم أبدًا. يُستعملان فقط لإعلامك وربط الاتصال بك."},"done":{"title":"تم نشر بحثك","text":"يبقى ظاهرًا حتى {{date}}.","mine":"عرض طلبات بحثي","view":"عرض البحث المنشور","another":"بحث جديد"},"mine":{"title":"طلبات بحثي","new":"جديد","tabActive":"النشطة","tabClosed":"المغلقة","tabExpired":"المنتهية","empty":"لا يوجد بحث في هذا الصنف.","published":"نُشر في {{date}}","expires":"ينتهي في {{date}}","expiredOn":"انتهى في {{date}}","closedOn":"أُغلق في {{date}}","proposals":"{{count}} اقتراح(ات) واردة","edit":"تعديل","close":"إغلاق","delete":"حذف","closeQuestion":"هل تريد إغلاق هذا البحث؟","closeNote":"لن يراه المعلنون بعد الآن.","deleteQuestion":"هل تريد حذف هذا البحث نهائيًا؟","deleteNote":"سيختفي من طلبات بحثك ومن القائمة العامة.","cancel":"إلغاء","closed":"تم إغلاق البحث.","deleted":"تم حذف البحث.","loadMore":"عرض المزيد","retry":"إعادة المحاولة","loading":"جارٍ التحميل…"},"edit":{"title":"تعديل بحثي","save":"حفظ","saving":"جارٍ الحفظ…","saved":"تم تحديث البحث.","expiryNote":"التعديل لا يمدّد مدة النشر: ينتهي في {{date}}.","notEditable":"هذا البحث غير موجود أو لم يعد نشطًا.","back":"العودة إلى طلبات بحثي"},"list":{"title":"طلبات البحث عن عقار","subtitle":"أشخاص يبحثون عن عقار. اقترح عقارك إن كان مناسبًا.","start":"أبحث عن عقار","allTransactions":"كل المعاملات","allTypes":"كل الأنواع","allCities":"كل الولايات","empty":"لا يوجد بحث مطابق.","view":"عرض البحث","previous":"السابق","next":"التالي","page":"الصفحة {{page}} من {{pages}}"},"detail":{"published":"نُشر في {{date}}","expires":"ينتهي في {{date}}","description":"الوصف","privacy":"لا تُعرض معطيات الاتصال بصاحب البحث.","back":"كل طلبات البحث"},"status":{"Active":"نشط","Closed":"مغلق","Expired":"منتهٍ"},"cardTitle":"{{type}} في {{place}}","errors":{"transactionRequired":"اختر شراء أو كراء أو كراء للعطلة.","categoryRequired":"اختر نوع عقار واحدًا على الأقل.","categoryInvalid":"هذا النوع غير متاح لهذه المعاملة.","cityRequired":"اختر الولاية.","cityInvalid":"ولاية غير معروفة.","tooManyDelegations":"5 معتمديات على الأكثر.","delegationInvalid":"معتمدية غير معروفة في هذه الولاية.","invalidNumber":"رقم غير صالح.","minAboveMax":"الحد الأدنى أكبر من الحد الأقصى.","invalidBedrooms":"عدد غرف غير صالح (من 0 إلى 30).","textTooLong":"1000 حرف على الأكثر.","preferenceRequired":"اختر طريقة التواصل.","emailRequired":"البريد الإلكتروني إلزامي لطريقة التواصل هذه.","emailInvalid":"بريد إلكتروني غير صالح.","phoneRequired":"الهاتف إلزامي لطريقة التواصل هذه.","phoneInvalid":"رقم هاتف غير صالح (من 8 إلى 15 رقمًا).","fixBelow":"صحّح الحقول المشار إليها.","invalid":"بعض المعطيات غير صالحة. تحقق من الاستمارة.","signIn":"سجّل الدخول للمتابعة.","forbidden":"هذا البحث لا يخصّك.","notFound":"البحث غير موجود أو محذوف.","tooManyActive":"لديك 10 طلبات بحث نشطة. أغلق واحدًا قبل نشر طلب جديد.","notActive":"هذا البحث لم يعد نشطًا ولا يمكن تعديله.","tooManyCreated":"نشرت 5 طلبات بحث خلال الساعة الأخيرة. أعد المحاولة بعد قليل.","tooManyRequests":"طلبات كثيرة. أعد المحاولة بعد لحظات.","tooManyRequestsWait_one":"طلبات كثيرة. أعد المحاولة بعد دقيقة واحدة.","tooManyRequestsWait_two":"طلبات كثيرة. أعد المحاولة بعد دقيقتين.","tooManyRequestsWait_few":"طلبات كثيرة. أعد المحاولة بعد {{count}} دقائق.","tooManyRequestsWait_many":"طلبات كثيرة. أعد المحاولة بعد {{count}} دقيقة.","tooManyRequestsWait_other":"طلبات كثيرة. أعد المحاولة بعد {{count}} دقيقة.","server":"الخدمة غير متاحة مؤقتًا. أعد المحاولة لاحقًا.","alreadyProposed":"لقد اقترحت هذا العقار من قبل.","requestClosed":"هذا البحث لم يعد يقبل الاقتراحات.","ownRequest":"لا يمكنك اقتراح عقار على بحثك الخاص.","listingNotOwned":"لا يمكنك اقتراح إلا إعلاناتك الخاصة.","listingNotFound":"هذا الإعلان غير موجود أو تم حذفه.","listingMismatch":"هذا الإعلان لا يناسب نوع البحث.","tooManyProposals":"اقتراحات كثيرة خلال وقت قصير. أعد المحاولة لاحقًا.","messageInvalid":"الرسالة طويلة جدًا (500 حرف على الأكثر).","chooseListing":"اختر أحد إعلاناتك."},"analysis":{"button":"تحليل بواسطة Lina AI","analyzing":"جارٍ التحليل…","needText":"اكتب بحثك أولًا.","done":"تم اكتشاف المعايير: تحقق منها وأكملها عند الحاجة.","nothing":"لم يتم اكتشاف أي معيار في نصك. أكمل المعايير أدناه.","unavailable":"Lina AI غير متاح حاليًا: تم اكتشاف المعايير المكتوبة صراحة فقط.","detected":"المعايير المكتشفة","remove":"حذف: {{label}}","manual":"أدخلته أنت","ai":"Lina AI","auto":"تحليل تلقائي للنص","unscored":"مذكور في نصك، ولا يُحتسب في الترتيب."},"matches":{"see":"عرض الإعلانات المطابقة","title":"الإعلانات المطابقة","loading":"جارٍ البحث في الإعلانات…","strong":"تطابق ممتاز","close":"تطابق جيد","alternative":"بدائل","badgeStrong":"تطابق ممتاز","badgeClose":"تطابق جيد","badgeAlternative":"بديل","none":"لم نجد عقارًا يطابق بحثك بما يكفي.","publishQuestion":"هل تريد نشر بحثك؟","noneFit":"لا يناسبك أي من هذه الإعلانات؟","publish":"نشر بحثي","edit":"تعديل بحثي","view":"عرض الإعلان","why":"لماذا هذا الإعلان","noPhoto":"الصورة غير متوفرة","bedrooms":"{{count}} غرفة"},"why":{"matches":"يتوافق مع {{items}}.","budget":"ميزانيتك","place":"{{place}}","surface":"المساحة المطلوبة","bedrooms":"عدد الغرف","attributes":"التجهيزات: {{items}}","budgetAbove":"السعر يتجاوز ميزانيتك بنسبة {{percent}}٪.","budgetBelow":"السعر أقل من ميزانيتك الدنيا بنسبة {{percent}}٪.","priceUnknown":"السعر غير مذكور.","surfaceBelow":"المساحة أصغر من طلبك بنسبة {{percent}}٪.","surfaceAbove":"المساحة أكبر من طلبك بنسبة {{percent}}٪.","surfaceUnknown":"المساحة غير مذكورة.","locationSameCity":"يقع في {{place}}: نفس الولاية، معتمدية أخرى.","bedroomsMissing":"ينقص {{count}} غرفة.","attributesMissing":"بدون: {{items}}.","typeOther":"نوع العقار مختلف.","locationOther":"الولاية مختلفة."},"propose":{"title":"اقتراح عقار","action":"اقتراح عقار","choose":"اختر عقارًا لاقتراحه","onlyOwn":"تظهر فقط إعلاناتك النشطة المناسبة لهذا البحث.","none":"ليس لديك أي إعلان نشط من هذا النوع.","noneFor":"ليس لديك أي إعلان نشط من نوع «{{type}}». هذا البحث يخص: {{transaction}}.","createListing":"نشر إعلان","select":"اختيار: {{title}}","message":"رسالة (اختياري)","messagePlaceholder":"قدّم عقارك في بضع كلمات.","messageNotice":"لا تكتب رقم هاتف أو بريدًا إلكترونيًا أو رابطًا: سيتم إخفاؤها. سيتواصل معك الشخص عبر لينا إيمو.","submit":"إرسال الاقتراح","sending":"جارٍ الإرسال…","sent":"تم إرسال اقتراحك.","alreadyProposed":"تم اقتراحه","withdraw":"سحب اقتراحي","withdrawn":"تم سحب الاقتراح.","closed":"هذا البحث لم يعد يقبل الاقتراحات.","ownRequest":"هذا بحثك الخاص: لا يمكنك اقتراح عقار عليه.","scoreNotice":"يُحتسب مستوى التطابق تلقائيًا. يمكنك اقتراح عقار مطابق جزئيًا: سيرى الشخص الفروق."},"level":{"excellent":"ممتاز","good":"جيد","partial":"جزئي"},"received":{"show":"عرض الاقتراحات ({{count}})","hide":"إخفاء الاقتراحات","title":"الاقتراحات الواردة","newCount":"{{count}} جديد","newBadge":"جديد","none":"لا توجد اقتراحات حاليًا.","from":"اقترحه {{name}}","fromUnknown":"اقترحه معلن","date":"في {{date}}","message":"رسالة المعلن","unavailable":"هذا الإعلان لم يعد متاحًا.","loading":"جارٍ تحميل الاقتراحات…"}},
    "administration": {"visitorsTitle":"الزوار","visitorsToday":"اليوم","visitorsTotal":"المجموع منذ الإطلاق","visitorsLast7Days":"آخر 7 أيام","visitorsCount":"الزوار","visitorsError":"إحصائيات الزوار غير متاحة.","listingTitle":"العنوان","amount":"المبلغ","title":"إدارة لينا إيمو","overview":"لوحة التحكم","listings":"الإعلانات","vacations":"إيجارات العطلات","users":"المستخدمون","reservations":"الحجوزات","navigation":"الإدارة","back":"العودة إلى الموقع","loading":"جارٍ التحميل…","denied":"الدخول للمشرفين فقط","signIn":"تسجيل الدخول","search":"العنوان أو الناشر","searchUsers":"الاسم أو البريد الإلكتروني","city":"المدينة","delegation":"المعتمدية","type":"النوع","status":"الحالة","all":"الكل","active":"منشور","deleted":"محذوف","sale":"بيع","rent":"إيجار","night":"عطلات / ليلة","filter":"تصفية","reset":"إعادة ضبط","retry":"إعادة المحاولة","sales":"للبيع","rents":"للإيجار","lands":"الأراضي","pending":"حجوزات قيد الانتظار","total":"{{count}} نتيجة","photo":"الصورة","author":"الناشر","price":"السعر","date":"التاريخ","actions":"الإجراءات","name":"الاسم","email":"البريد الإلكتروني","registeredAt":"تاريخ التسجيل","role":"الدور","listingCount":"الإعلانات النشطة","host":"المضيف","traveler":"المسافر","arrival":"الوصول","departure":"المغادرة","view":"عرض الإعلان","viewAuthor":"عرض الناشر","delete":"حذف نهائي","deleteQuestion":"هل تريد حذف هذا الإعلان نهائياً؟","deleteNote":"سيُزال الإعلان من الموقع. يُحتفظ بسجل المحادثات والحجوزات المرتبطة وفق القواعد الحالية.","cancel":"إلغاء","deleting":"جارٍ الحذف…","empty":"لا توجد نتائج","previous":"السابق","next":"التالي","page":"الصفحة {{number}}","currency":"د.ت","Admin":"مشرف","User":"مستخدم","EnAttente":"قيد الانتظار","Acceptee":"مقبول","Rejetee":"مرفوض","Annulee":"ملغى"},
    "publisher": {"title":"نُشر بواسطة","role":"المعلن","message":"رسالة","phone":"الهاتف","send":"إرسال","sending":"جارٍ الإرسال…","sent":"تم إرسال الرسالة."},
    "saveSearch": {"question":"هل تريد حفظ هذا البحث؟","save":"حفظ","saving":"جارٍ الحفظ…","dismiss":"لا، شكرًا","saved":"تم حفظ البحث في عمليات البحث الأخيرة.","error":"تعذّر حفظ هذا البحث."},
    "seo": {"categorySale":"عقارات للبيع في تونس","categoryRent":"عقارات للإيجار في تونس","categoryAll":"إعلانات عقارية في تونس","offers":"عروض عقارية في تونس","vacation":"إيجارات العطلات في تونس","city":"عقارات في {{city}}","searchCity":"إعلانات عقارية في {{city}}","requests":"طلبات البحث عن عقار","request":"أبحث عن عقار","listing":"إعلان عقاري","vacationListing":"إيجار عطلة","notFound":"الإعلان غير موجود"},
    "mobile": {"search":"البحث عن إعلان","notifications":"الإشعارات","filters":"الفلاتر","closeFilters":"إغلاق الفلاتر","popular":"وجهات شائعة","viewMap":"عرض على الخريطة","favorites":"المفضّلة","arrival":"الوصول","departure":"المغادرة","language":"اللغة"},
    "mapZone": {
"bedrooms":"غرف النوم: {{count}}",
"perSquareMetre":"{{price}} د.ت/م²",
  "draw": "ارسم منطقة بحث",
  "edit": "تعديل المنطقة",
  "clear": "مسح المنطقة",
  "apply": "تطبيق المنطقة",
  "undo": "حذف آخر نقطة",
  "cancel": "إلغاء",
  "instructions": "اضغط على الخريطة لإضافة نقاط. لتحريك نقطة اضغط عليها ثم على موقعها الجديد. اضغط تطبيق عند الانتهاء.",
  "moveVertex": "اضغط على الموقع الجديد للنقطة.",
  "invalid": "ارسم مضلعاً بثلاث نقاط على الأقل دون تقاطع.",
  "empty": "لا توجد إعلانات محمّلة داخل هذه المنطقة.",
  "loaded": "البحث داخل المنطقة: {{count}} إعلان من النتائج المحمّلة حالياً.",
  "all": "كل الإعلانات المحمّلة",
  "indicative": "المباني ثلاثية الأبعاد توضيحية: قد تكون الارتفاعات تقديرية حسب مصدر الخريطة."
},
    "mapView": {
      "about": "حول الخريطة",
      "searchArea": "عرض {{count}} عقارات محمّلة في هذه المنطقة",
      "sameLocation": "في هذا الموقع",
      "previous": "العقار السابق",
      "next": "العقار التالي",
      "choose":"اختر إعلانًا من المجموعة",
      "display":"عرض النتائج","list":"قائمة","map":"خريطة","loading":"جارٍ تحميل الخريطة…",
      "count":"عدد العقارات المعروضة على الخريطة: {{count}}","loadedOnly":"تعرض الخريطة النتائج المحمّلة فقط. استخدم «عرض المزيد» لتحميل نتائج إضافية.",
      "excluded":"عدد الإعلانات المحمّلة دون موقع صالح: {{count}}. يمكنك مشاهدتها في القائمة.",
      "noCoordinates":"لا تتوفر مواقع صالحة للإعلانات المحمّلة.",
      "noProvider":"لم يتم إعداد خلفية الخريطة. يمكنك الاطلاع على المواقع أو العودة إلى القائمة.",
      "tileError":"خلفية الخريطة غير متوفرة مؤقتًا. تظل العلامات والقائمة متاحتين.",
      "unavailable":"تعذّر تحميل الخريطة. ارجع إلى القائمة لمشاهدة الإعلانات.",
      "cluster":"{{count}} إعلانات: تكبير أو فتح المجموعة","preview":"معاينة الإعلان","close":"إغلاق المعاينة",
      "noPrice":"عرض الإعلان","price":"{{price}} د.ت","monthlyPrice":"{{price}} د.ت/شهر","nightlyPrice":"{{price}} د.ت/ليلة"
    },
    "listingSort": {"label":"ترتيب حسب:","recent":"الأحدث","price_asc":"السعر تصاعدياً","price_desc":"السعر تنازلياً","price_m2_asc":"سعر المتر المربع تصاعدياً","price_m2_desc":"سعر المتر المربع تنازلياً","surface_asc":"المساحة تصاعدياً","surface_desc":"المساحة تنازلياً","bedrooms_asc":"عدد الغرف تصاعدياً","bedrooms_desc":"عدد الغرف تنازلياً","night_price_asc":"سعر الليلة تصاعدياً","night_price_desc":"سعر الليلة تنازلياً"},
    "vacationPrice": {"price":"السعر","minimum":"السعر الأدنى","maximum":"السعر الأقصى","unit":"دينار تونسي / ليلة","apply":"تطبيق","from":"ابتداءً من","until":"حتى","invalid":"أدخل أسعارًا أكبر من أو تساوي صفرًا، على أن يكون الحد الأدنى أقل من أو يساوي الحد الأقصى."},
    "stay": {"weeklyDiscount":"خصم أسبوعي","monthlyDiscount":"خصم شهري","estimatedTotal":"المجموع التقديري","leaveDraft":"هل تريد مغادرة النموذج وفقدان المعلومات غير المحفوظة؟"},
    "publicEmail": {
      "title": "اتصل بنا",
      "intro": "لديك سؤال حول لينا إيمو؟ تجد بيانات الاتصال أدناه.",
      "home": "الرئيسية",
      "address": "العنوان",
      "city": "القيروان، تونس",
      "telephone": "الهاتف",
      "whatsappHint": "يفتح واتساب في علامة تبويب جديدة",
      "formTitle": "أرسل لنا رسالة",
      "lastName": "اللقب",
      "firstName": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف (اختياري)",
      "message": "الرسالة",
      "send": "إرسال",
      "sending": "جارٍ الإرسال…",
      "required": "هذا الحقل مطلوب.",
      "invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صالح.",
      "contactSuccess": "تم إرسال رسالتك. شكرًا لتواصلك معنا.",
      "sendError": "تعذّر تأكيد الإرسال. يرجى المحاولة لاحقًا.",
      "notConfigured": "الإرسال غير متاح مؤقتًا. يرجى المحاولة لاحقًا.",
      "newsletterTitle": "ابقَ على اطلاع مع لينا إيمو",
      "newsletterText": "تلقَّ الإعلانات الجديدة والمستجدات وأخبار لينا إيمو مباشرة عبر البريد الإلكتروني.",
      "emailPlaceholder": "عنوان بريدك الإلكتروني",
      "subscribe": "اشترك",
      "newsletterSuccess": "تم إرسال طلب اشتراكك في النشرة البريدية. شكرًا لك!"
},
    "my_profile": "ملفّي الشخصي",
    "want_to_edit_name": "هل تريد تعديل اسمك؟",
    "edit": "تعديل",
    "apply_changes": "حفظ",
    "logout": "تسجيل الخروج",
    "delete_account": "حذف حسابي",
    "delete_reason_placeholder": "سبب الحذف (اختياري)",
    "confirm_delete_account": "حذف نهائي",
    "fill_reason_before_delete": "يمكنك إخبارنا بسبب مغادرتك.",
    "profile_updated": "تم تحديث الملف الشخصي.",
    "profile_update_error": "تعذّر تحديث ملفّك الشخصي.",
    "account_deleted": "تم حذف حسابك.",
    "account_delete_error": "تعذّر حذف حسابك.",
    "write_message": "اكتب رسالتك…",
    "month": "شهر",
    "send": "إرسال",
    "location_Vacation": "اعثر على سكن لعطلتك",
    "location_day": "إيجار يومي ",
    "email_placeholder": "عنوان البريد الإلكتروني",
    "reset_password": "إعادة تعيين كلمة المرور",
    "email_sent": "تم إرسال البريد الإلكتروني",
    "reset_password_error": "تعذر إرسال كلمة مرور إعادة التعيين",
    "message": "رسالة",
    "call": "اتصال",
    "sign_in": "تسجيل الدخول",
    "password_placeholder": "كلمة المرور",
    "incorrect_email_password": "البريد الإلكتروني و/أو كلمة المرور غير صحيحة",
    "no_account": "ليس لديك حساب؟",
    "sign_up": "اشترك",
    "forgot_password": "هل نسيت كلمة المرور؟",
    "or": "أو",
    "find_your_dream_property": "Lina immo",
    "show_conversations": "عرض المحادثات",
    "hide_conversations": "إخفاء المحادثات",
    "details_vacation": {
      "sending": "جارٍ الإرسال...",
      "send_reservation": "إرسال الطلب",
      "sending_in_progress": "جارٍ إرسال الحجز...",
      "reservation_sent": "تم إرسال طلب الحجز.",
      "contact_us": "اتصل بنا",
      "our_cities": "استكشف حسب المدينة",
      "title": "معلومات عن الشقة",
      "guests": "{{count}} مسافر",
      "bedrooms": "غرف النوم: {{count}} · الأسرّة: {{beds}}",
      "bathrooms": "حمام",
      "amenities": "التجهيزات",
      "arrival_date": "الوصول",
      "departure_date": "المغادرة",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "WhatsApp": "واتساب",
      "message": "الرسالة",
      "total_days": "عدد الأيام :",
      "total_price": "المجموع التقديري",
      "discount_applied": "تخفيض",
      "per_night": "لليلة الواحدة",
      "no_listings": "حاليًا، لا توجد إعلانات ",
      "follow_us": "تابعونا",
      "newsletter": "النشرة الإخبارية",
      "newsletter_text": "تلقَّ أحدث الإعلانات والفرص العقارية الجديدة.",
      "your_email": "بريدك الإلكتروني",
      "subscribe": "اشترك",
      "selectDay": "اختيار",
      "invalid_email": "يرجى إدخال بريد إلكتروني صالح.",
      "login_required": "يرجى تسجيل الدخول للحجز.",
      "invalid_dates": "اختر تواريخ صالحة.",
      "email_error": "حدث خطأ أثناء الإرسال.",
      "reserve": "حجز",
      "booking_request": "طلب حجز",
      "nights": "ليالٍ",
      "load_error": "تعذّر تحميل هذا السكن.",
      "network_error": "حدث خطأ في الشبكة.",
      "load_error_title": "تعذّر تحميل هذا السكن",
      "no_amenities": "لم يتم تحديد تجهيزات."
    },
    "amenities": {
      "wifi": "واي فاي",
      "workspace": "مساحة عمل",
      "parking": "موقف مجاني في الموقع",
      "piscine": "مسبح داخلي خاص",
      "tv": "تلفاز",
      "camera": "كاميرات مراقبة",
      "barbecue": "شواية",
      "beachAccess": "وصول إلى الشاطئ",
      "ac": "تكييف"
    },
    "Profile": {
      "succes": "تم الحذف بنجاح",
      "echec": "فشلت عملية الحذف"
    },
    "listing": {
      "alreadyContacted": "تم التواصل مسبقًا",
      "alreadyContactedMessage": "لقد تواصلت مع مالك هذا العقار من قبل.",
      "noData": "لم يتم العثور على هذا الإعلان.",
      "contactLandlord": "اتصل بالمعلن",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "addMessage": "الرسالة",
      "description": "الوصف",
      "shareLinkCopied": "تم نسخ الرابط",
      "rent": "للإيجار",
      "sale": "للبيع",
      "bedroom": " غرفة",
      "bathroom": " حمام",
      "parking": "موقف سيارات",
      "noParking": "بدون موقف سيارات",
      "furnished": "مفروش",
      "notFurnished": "غير مفروش",
      "showNumber": "عرض الرقم",
      "message": "مرحبا، أنا مهتم بعقارك، هل لا يزال متاحا؟",
      "available": "متاح",
      "month": "شهر",
      "untitled": "إعلان عقاري",
      "locationUnavailable": "الموقع غير محدد",
      "bedroomsShort": "غرف نوم",
      "bathroomsShort": "حمّامات",
      "surface": "المساحة",
      "viewLand": "عرض الأرض",
      "viewDetails": "عرض المسكن",
      "new": "جديد",
      "bathrooms": "حمّامات",
      "loadingError": "تعذّر تحميل هذا الإعلان.",
      "completeFields": "يرجى ملء جميع الحقول.",
      "networkError": "حدث خطأ في الشبكة.",
      "loadingTitle": "تعذّر تحميل الإعلان",
      "property": "إعلان عقاري",
      "youSave": "وفّر",
      "noDescription": "لا يوجد وصف متاح.",
      "location": "الموقع",
      "openMaps": "فتح في الخرائط",
      "contactDescription": "احصل على مزيد من المعلومات أو رتّب زيارة لهذا العقار.",
      "messageSent": "تم إرسال رسالتك.",
      "sendMessage": "إرسال رسالة",
      "namePlaceholder": "اسمك",
      "send": "إرسال الرسالة",
      "ownerNotice": "أنت مالك هذا الإعلان.",
      "bedrooms": "غرف النوم"
    },
    "entirePlace": "سكن كامل",
    "oneRoom": "غرفة واحدة",
    "sharedRoom": "غرفة مشتركة",
    "add_ad": "نشر إعلان",
    "add_ad_short": "نشر إعلان",
    "title": "السكن",
    "options": {
      "description": "التجهيزات والخدمات",
      "wifi": "واي فاي",
      "tv": "تلفاز",
      "cuisine": "مطبخ",
      "lavelinge": "غسالة",
      "Parking": "موقف سيارات",
      "climatisation": "تكييف هواء",
      "espacedetravail": "مساحة عمل",
      "picine": "مسبح",
      "barbecue": "مشواء",
      "jardin": "حديقة",
      "accesauplage": "على الشاطئ",
      "camera": "كاميرا مراقبة",
      "parking": "موقف سيارات",
      "furnished": "مفروش"
    },
    "maps": "حدد الموقع",
    "yes": "نعم",
    "no": "لا",
    "no_conversation": "لا توجد محادثات",
    "create_ad": "نشر إعلان",
    "No_ads": "لا يوجد إعلانات حاليًا",
    "No_request": "لا توجد طلبات حاليًا",
    "No_reserved": "لا توجد حجوزات حاليًا",
    "ads": "إعلانات ",
    "create_adW": "نشر إعلان إيجار سياحي",
    "update_ad": "تحديث إعلان الإيجار",
    "m²": "م²",
    "sell / rent": "بيع أو إيجار",
    "sell - rent": "بيع/ إيجار",
    "sell": "بيع",
    "rent": "إيجار",
    "choose_property_type": "نوع العقار",
    "apartment": "شقة",
    "house": "منزل",
    "commercial": "تجاري",
    "land": "أرض",
    "others": "أخرى",
    "label": "عنوان الإعلان",
    "SoldeW": "تخفيض أسبوعي",
    "SoldeW_": "لإقامة مدّتها أسبوع",
    "SoldeM": "تخفيض شهري",
    "SoldeM_": "لإقامة مدّتها شهر",
    "Contacts": "بيانات الاتصال الخاصة بك",
    "surface": "المساحة",
    "price": "السعر لليلة الواحدة",
    "city": "جميع المدن",
    "delegation": "جميع المعتمديات",
    "offer": "عرض خاص",
    "non": "لا",
    "address": "العنوان",
    "postal_code": "الرمز البريدي",
    "bathrooms": "حمّامات",
    "bathroom": "الحمامات",
    "bedrooms": "غرف نوم",
    "parking": "موقف سيارات",
    "furnished": "مفروش",
    "add_image": "إضافة صورة",
    "choose_file": "اختر ملفًا",
    "no_file_selected": "لم يتم اختيار أي ملف",
    "Kairouan": "ٱلْقَيْرَوَان",
    "home": "الرئيسية",
    "buy": "شراء",
    "enterAdres": "أدخل عنوانًا",
    "offers": "العروض",
    "recent_offers": "العروض الأخيرة",
    "see_all_offers": "شاهد جميع العروض",
    "see_plus": "عرض المزيد",
    "no_exact_match": "لم يتم العثور على إيجارات",
    "modify_filters": "غيّر الوجهة أو عدد الأشخاص للعثور على المزيد من المساكن.",
    "for_rent": "للإيجار",
    "see_all_ads": "شاهد جميع الإعلانات",
    "for_sale": "للبيع",
    "fetch_fail": "فشل في جلب البيانات",
    "fetch_error": "حدث خطأ :",
    "recent_searches": "عمليات البحث الأخيرة",
    "recently_viewed": "الإعلانات التي شاهدتها مؤخرًا",
    "my_favorites": "المفضّلة",
    "my_annonce": "إعلاناتي",
    "my_reservation": "حجوزاتي",
    "my_message": "الرسائل",
    "my_profil": "ملفي الشخصي",
    "my_demande": "طلبات الحجز",
    "my_alerts": "تنبيهاتي",
    "SelectCity": "اختر مدينة",
    "numtel": "الهاتف",
    "previous": "السابق",
    "continue": "متابعة",
    "email": "البريد الإلكتروني",
    "search": "أدخل العنوان أو المدينة في تونس",
    "vacances": "إيجارات العطلات",
    "guesthouse": "دار الضيافة",
    "partyrooms": "قاعات الافراح",
    "guestNumbers": "عدد الأشخاص",
    "cities": {
      "Tunis": "تونس",
      "Sfax": "صفاقس",
      "Kairouan": "القيروان",
      "Ariana": "أريانة",
      "Béja": "باجة",
      "Ben Arous": "بن عروس",
      "Bizerte": "بنزرت",
      "Gabès": "قابس",
      "Gafsa": "قفصة",
      "Jendouba": "جندوبة",
      "Kasserine": "القصرين",
      "Kébili": "قبلي",
      "Le Kef": "الكاف",
      "Mahdia": "المهدية",
      "Manouba": "منوبة",
      "Médenine": "مدنين",
      "Monastir": "المنستير",
      "Nabeul": "نابل",
      "Sidi Bouzid": "سيدي بوزيد",
      "Siliana": "سليانة",
      "Sousse": "سوسة",
      "Tataouine": "تطاوين",
      "Tozeur": "توزر",
      "Zaghouan": "زغوان",
      "Kef": "الكاف",
      "Hammamet": "الحمامات"
    },
    "delegations": {
      "Tunis": {
        "Bab El Bhar": "باب البحر",
        "Bab Souika": "باب سويقة",
        "Carthage": "قرطاج",
        "Cité El Khadra": "حي الخضراء",
        "Djebel Jelloud": "جبل الجلود",
        "El Kabaria": "الكبارية",
        "El Menzah": "المنزه",
        "El Omrane": "العمران",
        "El Omrane Supérieur": "العمران الأعلى",
        "El Ouardia": "الوردية",
        "Ettahrir": "التحرير",
        "Ezzouhour": "الزهور",
        "Hrairia": "الحرائرية",
        "La Goulette": "حلق الوادي",
        "La Marsa": "المرسى",
        "Le Bardo": "باردو",
        "Le Kram": "الكرم",
        "Médina": "المدينة",
        "Séjoumi": "الساجومي",
        "Sidi El Béchir": "سيدي البشير",
        "Sidi Hassine": "سيدي حسين"
      },
      "Sfax": {
        "Sakiet Eddaier": "ساقية الدائر",
        "Sakiet Ezzit": "ساقية الزيت",
        "Sfax Ouest": "صفاقس الغربية",
        "Sfax Sud": "صفاقس الجنوبية",
        "Sfax Ville": "صفاقس المدينة",
        "Thyna": "طينة",
        "El Amra": "العامرة",
        "El Hencha": "الحنشة",
        "Graïba": "الغريبة",
        "Jebeniana": "جبنيانة",
        "Kerkennah": "قرقنة",
        "Mahrès": "المحرص",
        "Menzel Chaker": "منزل شاكر"
      },
      "Kairouan": {
        "Kairouan Nord": "القيروان الشمالية",
        "Kairouan Sud": "القيروان الجنوبية",
        "Chebika": "الشبيكة",
        "Sbikha": "السبيخة",
        "Haffouz": "حفوز",
        "Hajeb El Ayoun": "حاجب العيون",
        "Oueslatia": "الوسلاتية",
        "Bou Hajla": "بوحجلة",
        "Nasrallah": "النصر الله",
        "Chrarda": "الشراردة"
      },
      "Ariana": {
        "Ariana Ville": "أريانة المدينة",
        "Ettadhamen": "التضامن",
        "Kalaat el Andalous": "قلعة الأندلس",
        "La Soukra": "سكرة",
        "Mnihla": "المنيهلة",
        "Raoued": "رواد",
        "Sidi Thabet": "سيدي ثابت"
      },
      "Béja": {
        "Amdoun": "عمدون",
        "Béja Nord": "باجة الشمالية",
        "Béja Sud": "باجة الجنوبية",
        "Goubellat": "قبلاط",
        "Medjez el Bab": "مجاز الباب",
        "Nefza": "نفزة",
        "Téboursouk": "تبرسق",
        "Testour": "تستور",
        "Thibar": "ثبار"
      },
      "Ben Arous": {
        "Ben Arous": "بن عروس",
        "Bou Mhel el Bassatine": "بومهل البساتين",
        "El Mourouj": "المروج",
        "Ezzahra": "الزهراء",
        "Fouchana": "فوشانة",
        "Hammam Chott": "حمام الشط",
        "Hammam Lif": "حمام الأنف",
        "Mohamedia": "المحمدية",
        "Mornag": "مرناق",
        "Nouvelle Medina": "المدينة الجديدة",
        "Radès": "رادس"
      },
      "Bizerte": {
        "Bizerte Nord": "بنزرت الشمالية",
        "Bizerte Sud": "بنزرت الجنوبية",
        "Djoumine": "جومين",
        "El Alia": "العالية",
        "Ghar El Melh": "غار الملح",
        "Ghezala": "غزالة",
        "Joumine": "جومين",
        "Mateur": "ماطر",
        "Menzel Bourguiba": "منزل بورقيبة",
        "Menzel Jemil": "منزل جميل",
        "Ras Jebel": "رأس الجبل",
        "Sejenane": "سجنان",
        "Tinja": "تينجة",
        "Utique": "أوتيك",
        "Zarzouna": "زارزونة"
      },
      "Gabès": {
        "Gabès Ville": "قابس المدينة",
        "Gabès Ouest": "قابس الغربية",
        "Gabès Sud": "قابس الجنوبية",
        "Ghannouch": "غنوش",
        "Mareth": "مارث",
        "Matmata": "مطماطة",
        "Menzel Habib": "منزل حبيب",
        "Métouia": "المطوية",
        "Nouvelle Matmata": "مطماطة الجديدة"
      },
      "Gafsa": {
        "Belkhir": "بلخير",
        "El Guettar": "القطار",
        "El Ksar": "القصر",
        "Gafsa Nord": "قفصة الشمالية",
        "Gafsa Sud": "قفصة الجنوبية",
        "Mdhilla": "المظيلة",
        "Metlaoui": "المتلوي",
        "Moularès": "أم العرائس",
        "Redeyef": "الرديف",
        "Sened": "سند",
        "Sidi Aïch": "سيدي عيش"
      },
      "Jendouba": {
        "Aïn Draham": "عين دراهم",
        "Balta-Bou Aouane": "بلطة بوعوان",
        "Bou Salem": "بوسالم",
        "Fernana": "فرنانة",
        "Ghardimaou": "غار الدماء",
        "Jendouba Nord": "جندوبة الشمالية",
        "Jendouba Sud": "جندوبة الجنوبية",
        "Oued Meliz": "وادي مليز",
        "Tabarka": "طبرقة"
      },
      "Kasserine": {
        "Djedeliane": "جدليان",
        "El Ayoun": "العيون",
        "Ezzouhour": "الزهور",
        "Fériana": "فريانة",
        "Foussana": "فوسانة",
        "Haïdra": "حيدرة",
        "Hassi El Ferid": "حاسي الفريد",
        "Kasserine Nord": "القصرين الشمالية",
        "Kasserine Sud": "القصرين الجنوبية",
        "Majel Bel Abbès": "ماجل بلعباس",
        "Sbeitla": "سبيطلة",
        "Sbiba": "سبيبة",
        "Thala": "تالة"
      },
      "Kébili": {
        "Douz Nord": "دوز الشمالية",
        "Douz Sud": "دوز الجنوبية",
        "Faouar": "الفوار",
        "Kébili Nord": "قبلي الشمالية",
        "Kébili Sud": "قبلي الجنوبية",
        "Souk Lahad": "سوق الأحد"
      },
      "Le Kef": {
        "Dahmani": "الدهماني",
        "Jérissa": "الجريصة",
        "El Ksour": "القصور",
        "Le Kef Est": "الكاف الشرقية",
        "Le Kef Ouest": "الكاف الغربية",
        "Ksour": "القصور",
        "Nebeur": "نبر",
        "Sakiet Sidi Youssef": "ساقية سيدي يوسف",
        "Sers": "السراس",
        "Tajerouine": "تاجروين"
      },
      "Mahdia": {
        "Bou Merdes": "بو مرداس",
        "Chorbane": "شربان",
        "El Jem": "الجم",
        "Essouassi": "السواسي",
        "Hebira": "هبيرة",
        "Ksour Essef": "قصور الساف",
        "Mahdia": "المهدية",
        "Melloulech": "ملولش",
        "Ouled Chamekh": "أولاد الشامخ",
        "Sidi Alouane": "سيدي علوان"
      },
      "Manouba": {
        "Borj El Amri": "برج العامري",
        "Douar Hicher": "دوار هيشر",
        "El Battan": "البطان",
        "Jedaida": "الجديدة",
        "La Manouba": "منوبة",
        "Mornaguia": "المرناقية",
        "Oued Ellil": "وادي الليل",
        "Tebourba": "طبربة"
      },
      "Médenine": {
        "Ben Gardane": "بن قردان",
        "Beni Khedache": "بني خداش",
        "Djerba - Ajim": "جربة - أجيم",
        "Djerba - Houmt Souk": "جربة - حومة السوق",
        "Djerba - Midoun": "جربة - ميدون",
        "Médenine Nord": "مدنين الشمالية",
        "Médenine Sud": "مدنين الجنوبية",
        "Sidi Makhlouf": "سيدي مخلوف",
        "Zarzis": "جرجيس"
      },
      "Monastir": {
        "Bekalta": "بقالطة",
        "Bembla": "بمبلة",
        "Beni Hassen": "بني حسان",
        "Jemmal": "جمال",
        "Ksar Hellal": "قصر هلال",
        "Ksibet el Mediouni": "قصيبة المديوني",
        "Moknine": "المكنين",
        "Monastir": "المنستير",
        "Ouerdanine": "وردانين",
        "Sahline": "سهلين",
        "Sayada-Lamta-Bou Hjar": "صيادة لمطة بو حجار",
        "Teboulba": "طبلبة",
        "Zéramdine": "زرمدين"
      },
      "Nabeul": {
        "Béni Khalled": "بني خلاد",
        "Béni Khiar": "بني خيار",
        "Bou Argoub": "بو عرقوب",
        "Dar Chaâbane El Fehri": "دار شعبان الفهري",
        "El Haouaria": "الهوارية",
        "El Mida": "الميدة",
        "Grombalia": "قرمبالية",
        "Hammam Ghezèze": "حمام الغزاز",
        "Hammamet": "الحمامات",
        "Kélibia": "قليبية",
        "Korba": "قربة",
        "Menzel Bouzelfa": "منزل بوزلفة",
        "Menzel Temime": "منزل تميم",
        "Nabeul": "نابل",
        "Soliman": "سليمان",
        "Takelsa": "تاكلسة"
      },
      "Sidi Bouzid": {
        "Bir El Hafey": "بئر الحفي",
        "Cebbala Ouled Asker": "السبالة أولاد عسكر",
        "Jilma": "جلمة",
        "Meknassy": "المكناسي",
        "Mezzouna": "المزونة",
        "Menzel Bouzaiane": "منزل بوزيان",
        "Ouled Haffouz": "أولاد حفوز",
        "Regueb": "الرقاب",
        "Sidi Ali Ben Aoun": "سيدي علي بن عون",
        "Sidi Bouzid Est": "سيدي بوزيد الشرقية",
        "Sidi Bouzid Ouest": "سيدي بوزيد الغربية",
        "Souk Jedid": "سوق الجديد"
      },
      "Siliana": {
        "Bargou": "برقو",
        "Bou Arada": "بوعرادة",
        "El Aroussa": "العروسة",
        "Gaâfour": "قعفور",
        "El Krib": "الكريب",
        "Makthar": "مكثر",
        "Rouhia": "الروحية",
        "Sidi Bou Rouis": "سيدي بورويس",
        "Siliana Nord": "سليانة الشمالية",
        "Siliana Sud": "سليانة الجنوبية",
        "Kesra": "كسرى"
      },
      "Sousse": {
        "Bouhsina": "بوحسينة",
        "Chott Meriem": "شط مريم",
        "Kantaoui": "القنطاوي",
        "Khzema": "خزامة",
        "Messaadine": "المسعدين",
        "Swisse": "سويس",
        "Tafala": "الطفالة",
        "Ksiba": "قصيبة",
        "Akouda": "أكودة",
        "Bouficha": "بوفيشة",
        "Enfidha": "النفيضة",
        "Hammam Sousse": "حمام سوسة",
        "Hergla": "هرقلة",
        "Kalâa Kebira": "القلعة الكبرى",
        "Kalâa Seghira": "القلعة الصغرى",
        "Kondar": "كندار",
        "Msaken": "المساكن",
        "Sidi Bou Ali": "سيدي بوعلي",
        "Sidi El Hani": "سيدي الهاني",
        "Sousse Jawhara": "سوسة جوهرة",
        "Sousse Médina": "سوسة المدينة",
        "Sousse Riadh": "سوسة الرياض",
        "Sousse Sidi Abdelhamid": "سوسة سيدي عبد الحميد",
        "Sahloul": "سهلول",
        "Cité Zouhour": "حي الزهور",
        "Thrayat": "الثريات",
        "Zawiya": "الزاوية",
        "Cité Manazah": "حي المنازه"
      },
      "Tataouine": {
        "Bir Lahmar": "بئر الأحمر",
        "Dehiba": "الذهيبة",
        "Ghomrassen": "غمراسن",
        "Remada": "رمادة",
        "Samar": "الصمار",
        "Tataouine Nord": "تطاوين الشمالية",
        "Tataouine Sud": "تطاوين الجنوبية"
      },
      "Tozeur": {
        "Degache": "دقاش",
        "Hamet Jerid": "حامة الجريد",
        "Nefta": "نفطة",
        "Tozeur": "توزر",
        "Tameghza": "تمغزة"
      },
      "Zaghouan": {
        "Bir Mcherga": "بئر مشارقة",
        "El Fahs": "الفحص",
        "Nadhour": "الناظور",
        "Saouaf": "صواف",
        "Zaghouan": "زغوان",
        "Zriba": "زريبة"
      },
      "Kef": {
        "Dahmani": "الدهماني",
        "Jérissa": "الجريصة",
        "El Ksour": "القصور",
        "Le Kef Est": "الكاف الشرقية",
        "Le Kef Ouest": "الكاف الغربية",
        "Ksour": "القصور",
        "Nebeur": "نبر",
        "Sakiet Sidi Youssef": "ساقية سيدي يوسف",
        "Sers": "السراس",
        "Tajerouine": "تاجروين",
        "Kef Est": "الكاف الشرقية",
        "Kef Ouest": "الكاف الغربية"
      }
    },
    "create_ad_button": "أنشئ الإعلان",
    "lord": "المسافرون",
    "arrival": "الوصول",
    "destination": "الوجهة",
    "travelers": "الأشخاص",
    "add_travelers": "إضافة المسافرين",
    "depart": "المغادرة",
    "beds": "أسرّة",
    "rooms": "الغرف",
    "room": "غرفة",
    "Conversations": "المحادثة",
    "piece": "غرف",
    "delete": "حذف",
    "upload": "أضف الصور أو انقر فوق زر التحميل",
    "search_form": {
      "search_placeholder": "شقة، فيلا، أرض...",
      "advanced_search": "بحث متقدّم",
      "hide_advanced_search": "إخفاء عوامل التصفية",
      "all_cities": "كل المدن",
      "all_delegations": "جميع المعتمديات",
      "min_price": "السعر الأدنى",
      "max_price": "السعر الأقصى",
      "all_categories": "جميع الفئات",
      "category": "الفئة",
      "search": "بحث",
      "reset": "إعادة ضبط عوامل التصفية",
      "rooms": "عدد الغرف",
      "select_rooms": "عدد الغرف",
      "you_have": "لديك",
      "pending_notifications": "إشعارات معلقة",
      "name": "الاسم",
      "search_title": "اعثر على منزلك",
      "search_description": "اختر مدينة ثم حدّد معايير البحث.",
      "label": "العنوان أو الموقع",
      "select_category": "اختر فئة"
    },
    "contact": "تواصل",
    "request_date": "طلب",
    "start": "الوصول",
    "end": "المغادرة",
    "status": "الحالة",
    "actions": "الإجراءات",
    "validate": "قبول",
    "cancel": "إلغاء",
    "pending": "قيد الانتظار",
    "confirmed": "مؤكّدة",
    "rejected": "مرفوض",
    "canceled": "تم الإلغاء",
    "expired": "منتهية",
    "request_list": "طلبات الحجز",
    "list_title": "حجوزاتي",
    "no_requests": "لا توجد طلبات",
    "no_title": "لا توجد حجوزات",
    "error": "خطأ",
    "cancel_confirm": "هل تريد بالتأكيد رفض هذا الطلب؟",
    "cancel_success": "تم إلغاء الطلب",
    "accept_success": "تم قبول الطلب",
    "ui": {
      "page_not_found": "الصفحة غير موجودة.",
      "home": "الرئيسية",
      "you_are_not_signed_in": "لم تسجّل الدخول.",
      "unable_to_load_your_listings": "تعذّر تحميل إعلاناتك.",
      "are_you_sure_you_want_to_delete_this_listing": "هل تريد بالتأكيد حذف هذا الإعلان؟",
      "deletion_failed": "تعذّر الحذف.",
      "listing_deleted_successfully": "تم حذف الإعلان بنجاح.",
      "an_error_occurred_while_deleting": "حدث خطأ أثناء الحذف.",
      "my_property_dashboard": "مساحتي العقارية",
      "my_listings": "إعلاناتي",
      "you_have_not_published_any_listings_yet": "لم تنشر أي إعلان بعد.",
      "refresh": "تحديث",
      "add_a_listing": "إضافة إعلان",
      "no_listings_available": "لا توجد إعلانات متاحة",
      "publish_your_first_property_or_holiday_rental": "انشر أول إعلان لعقارك أو لإيجارك السياحي.",
      "list_a_property": "نشر إعلان عقار",
      "list_a_holiday_rental": "نشر إعلان إيجار سياحي",
      "holiday_rentals": "إيجارات سياحية",
      "properties": "العقارات",
      "what_this_accommodation_offers": "ما يقدّمه هذا المسكن",
      "lina_immo_property_listing": "إعلان عقاري على لينا إيمو",
      "for_rent": "للإيجار",
      "for_sale": "للبيع",
      "available": "متاح",
      "photos": "صور",
      "month": "شهر",
      "property_listing": "إعلان عقاري",
      "location_not_specified": "الموقع غير محدد",
      "beds": "غرف نوم",
      "baths": "حمّامات",
      "area": "المساحة",
      "yes": "نعم",
      "no": "لا",
      "parking": "موقف سيارات",
      "edit": "تعديل",
      "delete": "حذف",
      "view_details": "عرض التفاصيل",
      "unable_to_retrieve_the_data": "تعذّر جلب البيانات.",
      "contact": "تواصل",
      "contact_details": "بيانات الاتصال",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "WhatsApp": "واتساب",
      "profile": "الملف الشخصي",
      "user": "مستخدم",
      "email_unavailable": "البريد الإلكتروني غير متاح",
      "phone_number_not_provided": "رقم الهاتف غير مسجّل",
      "select_a_conversation": "اختر محادثة.",
      "conversations": "المحادثات",
      "search_conversations": "البحث في المحادثات",
      "listing_deleted": "تم حذف الإعلان",
      "about_this_listing": "حول هذا الإعلان",
      "view_messages": "عرض الرسائل",
      "delete_conversation": "حذف المحادثة",
      "no_conversations_found": "لم يتم العثور على محادثات",
      "all_your_conversations_in_one_place": "جميع محادثاتك في مكان واحد.",
      "please_enter_an_address": "يرجى إدخال عنوان.",
      "address_not_found": "العنوان غير موجود.",
      "unable_to_search_for_this_address_right_now": "تعذّر البحث عن هذا العنوان حاليًا.",
      "please_enter_the_address_city_and_delegation": "يرجى إدخال العنوان والمدينة والمعتمدية.",
      "address": "العنوان",
      "enter_an_address": "أدخل عنوانًا",
      "search_address": "البحث عن العنوان",
      "city": "المدينة",
      "select_a_city": "اختر مدينة",
      "postal_code": "الرمز البريدي",
      "delegation": "المعتمدية",
      "select_a_delegation": "اختر معتمدية",
      "map_preview": "معاينة الخريطة",
      "previous": "السابق",
      "continue": "متابعة",
      "describe_your_property": "صِف عقارك!",
      "bedrooms": "غرف النوم",
      "bathrooms": "الحمّامات",
      "upload_images_of_your_property": "أضف صورًا لعقارك",
      "unable_to_share_the_link_please_try_again": "تعذّرت مشاركة الرابط. يرجى المحاولة مجددًا.",
      "about_us": "من نحن",
      "terms_of_use": "شروط الاستخدام",
      "privacy_policy": "سياسة الخصوصية",
      "back_to_home": "العودة إلى الرئيسية",
      "rent_invest_negotiate_buy": "إيجار · استثمار · تفاوض · شراء",
      "find_your_next_home_list_your_property_and_discover_real_estate_opportunities_across_tunisia": "اعثر على مسكنك القادم وانشر عقارك واكتشف الفرص العقارية في تونس.",
      "navigation": "التصفّح",
      "explore_by_city": "استكشف حسب المدينة",
      "discover_available_properties_in_the_most_popular_cities": "اكتشف العقارات المتاحة في المدن الأكثر طلبًا.",
      "show_less": "عرض أقل",
      "view_all_cities": "عرض جميع المدن",
      "keep_in_touch": "لنبقَ على تواصل",
      "email_94": "البريد الإلكتروني",
      "kairouan_tunisia": "ٱلْقَيْرَوَان، تونس",
       "paris_france": "Paris, France",
      "newsletter": "النشرة البريدية",
      "get_the_latest_listings_and_new_property_opportunities": "تلقَّ أحدث الإعلانات والفرص العقارية الجديدة.",
      "your_email": "بريدك الإلكتروني",
      "subscribe_to_the_newsletter": "الاشتراك في النشرة البريدية",
      "sign_up": "التسجيل",
      "lina_immo_all_rights_reserved": "لينا إيمو. جميع الحقوق محفوظة.",
      "privacy": "الخصوصية",
      "terms": "الشروط",
      "back_to_top": "العودة إلى أعلى الصفحة",
      "menu": "القائمة",
      "close_menu": "إغلاق القائمة",
      "sale_or_long_term_rental": "بيع أو إيجار طويل المدى",
      "daily_or_holiday_rental": "إيجار يومي أو سياحي",
      "open_menu": "فتح القائمة",
      "close_mobile_menu": "إغلاق قائمة الهاتف",
      "lina_immo_home": "لينا إيمو — الرئيسية",
      "real_estate_made_simple": "العقارات بكل بساطة.",
      "main_navigation": "التصفّح الرئيسي",
      "mobile_menu": "قائمة الهاتف",
      "mobile_navigation": "التصفّح على الهاتف",
      "preview": "معاينة",
      "you_can_upload_up_to_6_images": "يمكنك تحميل 6 صور كحد أقصى.",
      "some_files_exceed_the_5_mb_limit_and_will_not_be_added": "تتجاوز بعض الملفات الحد الأقصى البالغ 5 ميغابايت ولن تُضاف.",
      "step_6": "الخطوة 6",
      "add_photos_of_your_property": "أضف صورًا لعقارك",
      "add_bright_high_quality_photos_to_make_your_listing_more_appealing": "أضف صورًا واضحة وجيدة الإضاءة لجعل إعلانك أكثر جاذبية.",
      "upload_photos": "تحميل الصور",
      "choose_a_main_photo_then_add_the_rooms_and_amenities": "اختر صورة رئيسية ثم أضف صور الغرف والتجهيزات.",
      "tips": "نصائح",
      "use_clear_bright_landscape_photos_avoid_blurry_or_dark_images": "استخدم صورًا أفقية واضحة وجيدة الإضاءة. تجنّب الصور الضبابية أو المظلمة.",
      "choose_a_language": "اختر لغة",
      "language": "اللغة",
      "view_listing": "عرض الإعلان",
      "rent": "إيجار",
      "sale": "بيع",
      "new": "جديد",
      "beds_140": "غرف نوم",
      "listing_displayed_on_the_home_page": "إعلان ظاهر في الصفحة الرئيسية",
      "no_images_available": "لا توجد صور متاحة",
      "host": "المضيف:",
      "tnd_night": "د.ت / ليلة",
      "please_enter_a_valid_email_address": "يرجى إدخال بريد إلكتروني صالح.",
      "please_sign_in_to_make_a_reservation": "يرجى تسجيل الدخول للحجز.",
      "select_valid_dates": "اختر تواريخ صالحة.",
      "your_booking_request_has_been_sent": "تم إرسال طلب الحجز.",
      "an_error_occurred_while_sending": "حدث خطأ أثناء الإرسال.",
      "holiday_rental": "إيجار سياحي",
      "holidays": "العطلات",
      "night": "ليلة",
      "guests": "ضيوف",
      "bedrooms_154": "غرف نوم",
      "book": "حجز",
      "call": "اتصال",
      "view_accommodation": "عرض المسكن",
      "lina_immo_holidays": "لينا إيمو للعطلات",
      "booking_request": "طلب حجز",
      "close": "إغلاق",
      "night_161": "/ ليلة",
      "check_in_date": "تاريخ الوصول",
      "select": "اختيار",
      "check_out_date": "تاريخ المغادرة",
      "guests_165": "الأشخاص",
      "name": "الاسم",
      "message": "الرسالة",
      "the_length_of_stay_discount_must_be_confirmed_before_booking": "يجب تأكيد تخفيض مدة الإقامة قبل الحجز.",
      "tnd": "د.ت ×",
      "nights": "ليالٍ",
      "discount_applied": "التخفيض المطبّق",
      "estimated_total": "المجموع التقديري",
      "sending": "جارٍ الإرسال...",
      "send_request": "إرسال الطلب",
      "locate_your_property": "حدّد موقع عقارك",
      "cost": "التكلفة",
      "latitude": "خط العرض",
      "longitude": "خط الطول",
      "contact_details_179": "بيانات الاتصال",
      "property_location": "موقع العقار",
      "find_this_address": "البحث عن هذا العنوان",
      "postal_code_182": "الرمز البريدي",
      "select_a_city_183": "اختر مدينة",
      "select_a_district": "اختر معتمدية",
      "view_conversations": "عرض المحادثات",
      "your_conversation_starts_here": "تبدأ محادثتك هنا",
      "ask_your_first_question_about_this_listing": "اطرح سؤالك الأول حول هذا الإعلان.",
      "this_listing_has_been_deleted_you_can_still_read_your_messages": "تم حذف هذا الإعلان. لا يزال بإمكانك الاطلاع على رسائلك.",
      "this_recipient_is_no_longer_available_you_can_still_read_your_messages": "لم يعد هذا المستلم متاحًا. لا يزال بإمكانك الاطلاع على رسائلك.",
      "your_message": "رسالتك",
      "write_your_message": "اكتب رسالتك…",
      "send": "إرسال",
      "enter_to_send_shift_enter_for_a_new_line": "Enter للإرسال · Shift + Enter لسطر جديد",
      "signed_in_with_google": "تم تسجيل الدخول باستخدام Google!",
      "unable_to_sign_in_with_google": "تعذّر تسجيل الدخول باستخدام Google.",
      "continue_with_google": "المتابعة باستخدام Google",
      "signing_in_with_google": "جارٍ تسجيل الدخول…",
      "google_popup_blocked": "تم حظر نافذة Google. اسمح بالنوافذ المنبثقة ثم أعد المحاولة.",
      "google_network_error": "لا يوجد اتصال بالإنترنت. أعد المحاولة.",
      "price": "السعر",
      "discounted_price": "السعر بعد التخفيض",
      "download_the_pdf_to_print": "تنزيل ملف PDF للطباعة",
      "describe_your_property_202": "صِف عقارك",
      "title": "العنوان",
      "description": "الوصف",
      "area_m": "المساحة (م²)",
      "number_of_bedrooms": "عدد غرف النوم",
      "number_of_bathrooms": "عدد الحمامات",
      "furnished": "مفروش",
      "tnd_209": "د.ت /",
      "total_price": "السعر الإجمالي:",
      "host_211": "المضيف:",
      "rating": "التقييم:",
      "reviews": "تقييمات)",
      "in_dinars": "بالدينار",
      "loading": "جارٍ التحميل...",
      "no_properties_available": "لا توجد عقارات متاحة",
      "month_217": "/ شهر",
      "loading_218": "جارٍ التحميل…",
      "no_vacation_rentals_available_at_the_moment": "لا توجد إيجارات للعطلات متاحة حاليًا.",
      "loading_220": "جارٍ التحميل...",
      "user_account": "حساب المستخدم",
      "my_account": "حسابي",
      "sign_in": "تسجيل الدخول",
      "create_an_account": "إنشاء حساب",
      "offer": "عرض",
      "sign_in_to_use_favorites": "سجّل الدخول لاستخدام المفضّلة.",
      "refresh_your_favorites_before_trying_again": "حدّث المفضّلة قبل المحاولة مجددًا.",
      "unable_to_load_requests": "تعذّر تحميل الطلبات.",
      "expired": "منتهٍ",
      "pending": "قيد الانتظار",
      "confirmed": "مؤكّد",
      "rejected": "مرفوض",
      "cancelled": "ملغى",
      "invalid_request_id": "معرّف الطلب غير صالح.",
      "unable_to_update_the_request": "تعذّر تحديث الطلب.",
      "request_accepted": "تم قبول الطلب.",
      "are_you_sure_you_want_to_reject_this_request": "هل تريد بالتأكيد رفض هذا الطلب؟",
      "request_rejected": "تم رفض الطلب.",
      "booking_requests": "طلبات الحجز",
      "view_incoming_requests_and_accept_or_reject_bookings": "اطّلع على الطلبات الواردة واقبل الحجوزات أو ارفضها.",
      "confirmed_242": "مؤكّدة",
      "rejected_243": "مرفوضة",
      "expired_244": "منتهية",
      "error": "خطأ",
      "accommodation": "السكن",
      "request_date": "تاريخ الطلب",
      "check_in": "الوصول",
      "check_out": "المغادرة",
      "accept": "قبول",
      "reject": "رفض",
      "request": "طلب",
      "status": "الحالة",
      "actions": "الإجراءات",
      "no_requests": "لا توجد طلبات",
      "you_have_no_booking_requests_to_review_at_the_moment": "ليس لديك طلبات حجز لمعالجتها حاليًا.",
      "unable_to_load_your_bookings": "تعذّر تحميل حجوزاتك.",
      "are_you_sure_you_want_to_cancel_this_booking": "هل تريد بالتأكيد إلغاء هذا الحجز؟",
      "booking_cancelled": "تم إلغاء الحجز.",
      "unable_to_cancel_the_booking": "تعذّر إلغاء الحجز.",
      "my_bookings": "حجوزاتي",
      "view_and_manage_all_your_booking_requests": "اطّلع على جميع طلبات الحجز وأدِرها.",
      "cancelled_263": "ملغاة",
      "booking": "حجز",
      "cancel": "إلغاء",
      "no_bookings": "لا توجد حجوزات",
      "you_have_no_bookings_to_display_at_the_moment": "ليس لديك حجوزات لعرضها حاليًا.",
      "error_268": "خطأ:",
      "text_search": "البحث النصّي:",
      "listings_found": "الإعلانات المتوفرة",
      "continue_to_the_next_listings": "متابعة عرض الإعلانات التالية",
      "offers_found_in": "العروض المتوفرة في",
      "hide_conversations": "إخفاء المحادثات",
      "show_conversations": "عرض المحادثات",
      "no_conversations": "لا توجد محادثات",
      "listing": "إعلان",
      "write_your_message_277": "اكتب رسالتك...",
      "select_a_conversation_to_get_started": "اختر محادثة للبدء.",
      "unable_to_load_your_conversations": "تعذّر تحميل محادثاتك.",
      "unable_to_load_this_conversation": "تعذّر تحميل هذه المحادثة.",
      "unable_to_send_the_message": "تعذّر إرسال الرسالة.",
      "do_you_want_to_delete_this_conversation": "هل تريد حذف هذه المحادثة؟",
      "unable_to_delete_this_conversation": "تعذّر حذف هذه المحادثة.",
      "sign_in_required": "يلزم تسجيل الدخول",
      "sign_in_to_view_your_conversations": "سجّل الدخول للاطّلاع على محادثاتك.",
      "your_conversations_with_owners_and_users_will_appear_here": "ستظهر هنا محادثاتك مع المالكين والمستخدمين.",
      "select_a_conversation_287": "اختر محادثة",
      "choose_a_conversation_to_view_its_messages": "اختر محادثة لعرض رسائلها.",
      "type": "النوع",
      "photos_290": "الصور",
      "select_the_transaction_and_property_type": "اختر نوع المعاملة والعقار.",
      "a_listing_title_is_required": "عنوان الإعلان مطلوب.",
      "enter_a_valid_area": "أدخل مساحة صالحة.",
      "enter_the_property_address": "أدخل عنوان العقار.",
      "enter_a_valid_price": "أدخل سعرًا صالحًا.",
      "the_discounted_price_must_be_below_the_original_price": "يجب أن يكون السعر المخفّض أقل من السعر الأصلي.",
      "enter_your_email_and_phone_number": "أدخل بريدك الإلكتروني ورقم هاتفك.",
      "you_must_be_signed_in_to_post_a_listing": "يجب تسجيل الدخول لنشر إعلان.",
      "add_at_least_one_photo": "أضف صورة واحدة على الأقل.",
      "your_listing_has_been_published_successfully": "تم نشر إعلانك بنجاح.",
      "unable_to_publish_the_listing": "تعذّر نشر الإعلان.",
      "enter_your_property_details_in_a_few_steps": "أدخل معلومات عقارك في بضع خطوات.",
      "what_type_of_listing_would_you_like_to_post": "ما نوع الإعلان الذي تريد نشره؟",
      "choose_the_transaction_and_property_type": "اختر نوع المعاملة والعقار.",
      "sale_or_rental": "بيع أو إيجار",
      "sell": "بيع",
      "rent_308": "إيجار",
      "property_type": "نوع العقار",
      "add_a_clear_title_and_the_main_features": "أضف عنوانًا واضحًا والخصائص الأساسية.",
      "listing_title": "عنوان الإعلان",
      "e_g_bright_apartment_in_tunis": "مثال: شقة مضيئة في تونس",
      "describe_the_highlights_of_your_property": "صِف أهم مميزات عقارك...",
      "enter_the_exact_address_so_buyers_can_easily_locate_your_property": "أدخل العنوان الدقيق ليتمكّن المشترون من تحديد موقع عقارك بسهولة.",
      "set_the_price": "حدّد السعر",
      "enter_the_property_price_and_optionally_add_a_discount": "أدخل سعر العقار وأضف تخفيضًا إن أردت.",
      "special_offer": "عرض خاص",
      "discounted_price_318": "السعر بعد التخفيض",
      "your_contact_details": "بيانات الاتصال الخاصة بك",
      "these_details_will_allow_interested_people_to_contact_you": "تتيح هذه البيانات للمهتمّين التواصل معك.",
      "add_your_photos": "أضف صورك",
      "add_bright_clear_photos_to_showcase_your_property": "أضف صورًا واضحة ومضيئة لإبراز عقارك.",
      "publishing": "جارٍ النشر...",
      "publish_listing": "نشر الإعلان",
      "address_not_found_325": "لم يتم العثور على العنوان",
      "listing_published": "تم نشر الإعلان.",
      "amenities": "التجهيزات",
      "capacity": "السعة",
      "rates": "الأسعار",
      "select_an_accommodation_type": "اختر نوع السكن.",
      "the_accommodation_must_host_at_least_one_person": "يجب أن يتّسع السكن لشخص واحد على الأقل.",
      "enter_a_valid_price_332": "أدخل سعرًا صالحًا.",
      "the_discounted_price_must_be_below_the_regular_price": "يجب أن يكون السعر المخفّض أقل من السعر العادي.",
      "enter_your_email_and_phone_number_334": "أدخل بريدك الإلكتروني ورقم هاتفك.",
      "your_vacation_rental_has_been_published": "تم نشر إعلان إيجار العطلات.",
      "unable_to_publish_your_listing": "تعذّر نشر إعلانك.",
      "present_your_accommodation_amenities_and_rates_in_a_few_steps": "قدّم سكنك وتجهيزاته وأسعاره في بضع خطوات.",
      "what_type_of_accommodation_do_you_offer": "ما نوع السكن الذي تقدّمه؟",
      "select_the_option_that_matches_your_rental": "اختر الصيغة المناسبة لسكنك.",
      "amenities_and_services": "التجهيزات والخدمات",
      "select_the_amenities_available_in_your_accommodation": "اختر التجهيزات المتوفرة في سكنك.",
      "locate_the_accommodation": "حدّد موقع السكن",
      "enter_the_address_and_check_the_location_on_the_map": "أدخل العنوان وتحقّق من الموقع على الخريطة.",
      "accommodation_capacity": "سعة السكن",
      "enter_the_number_of_guests_bedrooms_beds_and_bathrooms": "أدخل عدد الأشخاص وغرف النوم والأسرّة والحمامات.",
      "set_your_rates": "حدّد أسعارك",
      "enter_the_daily_rate_and_any_discounts": "أدخل السعر اليومي والتخفيضات المتاحة.",
      "price_per_night": "السعر لليلة الواحدة",
      "weekly_discount": "تخفيض أسبوعي",
      "for_a_one_week_stay": "لإقامة مدّتها أسبوع",
      "monthly_discount": "تخفيض شهري",
      "for_a_one_month_stay": "لإقامة مدّتها شهر",
      "these_details_will_allow_guests_to_contact_you": "تتيح هذه البيانات للضيوف التواصل معك.",
      "add_accommodation_photos": "أضف صور السكن",
      "choose_bright_photos_that_show_the_rooms_and_amenities": "اختر صورًا مضيئة تُظهر الغرف والتجهيزات.",
      "publish_rental": "نشر إعلان الإيجار",
      "wi_fi": "واي فاي",
      "dedicated_workspace": "مساحة عمل مخصّصة",
      "free_on_site_parking": "موقف مجاني في الموقع",
      "private_indoor_pool": "مسبح داخلي خاص",
      "tv": "تلفاز",
      "security_cameras": "كاميرات مراقبة",
      "barbecue": "شواية",
      "beach_access": "وصول إلى الشاطئ",
      "air_conditioning": "تكييف",
      "check_in_cannot_be_after_check_out": "لا يمكن أن يكون تاريخ الوصول بعد تاريخ المغادرة.",
      "sign_in_to_send_a_booking_request": "سجّل الدخول لإرسال طلب حجز.",
      "your_message_has_been_sent_successfully": "تم إرسال رسالتك بنجاح.",
      "error_369": "خطأ:",
      "apartment_information": "معلومات الشقة",
      "guest_s": "ضيوف",
      "bedroom_s": "غرف نوم ·",
      "bed_s": "أسرّة",
      "bathroom_s": "حمّامات",
      "phone_number": "رقم الهاتف:",
      "event_form": "استمارة المناسبة",
      "title_377": "اللقب *",
      "first_name": "الاسم *",
      "last_name": "اسم العائلة *",
      "event_type": "نوع المناسبة",
      "one_hour_marriage_ceremony": "عقد قران لمدة ساعة",
      "birthday": "عيد ميلاد",
      "other": "أخرى",
      "mobile_phone": "الهاتف الجوّال *",
      "email_385": "البريد الإلكتروني *",
      "event_date": "تاريخ المناسبة *",
      "start_time": "وقت البداية",
      "end_time": "وقت النهاية",
      "number_of_guests": "عدد المدعوّين *",
      "unable_to_load_this_rental": "تعذّر تحميل هذا السكن.",
      "a_network_error_occurred": "حدث خطأ في الشبكة.",
      "unable_to_load_this_rental_392": "تعذّر تحميل هذا السكن",
      "this_rental_could_not_be_found": "لم يتم العثور على هذا السكن.",
      "vacation_rental": "إيجار للعطلات",
      "tnd_395": "د.ت /",
      "beds_396": "أسرّة",
      "no_amenities_specified": "لم يتم تحديد تجهيزات.",
      "per_night": "لليلة الواحدة",
      "discount": "تخفيض",
      "guest_s_400": "ضيوف ·",
      "bed_s_401": "أسرّة ·",
      "1_guest": "ضيف واحد",
      "2_guests": "ضيفان",
      "3_guests": "3 ضيوف",
      "4_guests": "4 ضيوف",
      "5_guests": "5 ضيوف",
      "6_guests": "6 ضيوف",
      "7_guests": "7 ضيوف",
      "8_guests": "8 ضيوف",
      "tnd_410": "د.ت ×",
      "weekly_discount_411": "التخفيض الأسبوعي",
      "tnd_412": "د.ت)",
      "monthly_discount_413": "التخفيض الشهري",
      "tnd_414": "د.ت)",
      "total": "الإجمالي",
      "by_email": "عبر البريد الإلكتروني:",
      "or": "أو",
      "call_418": "اتصل:",
      "property": "عقار",
      "information": "المعلومات",
      "invalid_listing_id": "معرّف الإعلان غير صالح.",
      "you_do_not_own_this_listing": "أنت لست مالك هذا الإعلان.",
      "this_listing_could_not_be_found": "لم يتم العثور على هذا الإعلان.",
      "unable_to_retrieve_this_listing_s_information": "تعذّر جلب معلومات هذا الإعلان.",
      "no_changes_detected": "لم يتم رصد تغييرات.",
      "the_listing_has_been_updated": "تم تحديث الإعلان.",
      "unable_to_update_the_listing": "تعذّر تحديث الإعلان.",
      "unable_to_edit_the_listing": "تعذّر تعديل الإعلان",
      "back_to_my_listings": "العودة إلى إعلاناتي",
      "edit_listing": "تعديل الإعلان",
      "edit_your_listing_details_then_save_your_changes": "عدّل معلومات إعلانك ثم احفظ التغييرات.",
      "unsaved_changes": "تغييرات غير محفوظة",
      "step_1": "الخطوة 1",
      "property_information": "معلومات العقار",
      "edit_the_main_details_of_your_listing": "عدّل المعلومات الأساسية لإعلانك.",
      "step_2": "الخطوة 2",
      "additional_information": "معلومات إضافية",
      "complete_the_property_s_features_and_additional_details": "أكمل خصائص العقار ومعلوماته الإضافية.",
      "step_3": "الخطوة 3",
      "listing_photos": "صور الإعلان",
      "keep_remove_or_add_photos_to_your_listing": "احتفظ بصور إعلانك أو احذفها أو أضف صورًا.",
      "manage_photos": "إدارة الصور",
      "existing_photos_are_kept_unless_you_delete_them_you_can_also_add_new_ones": "تُحفظ الصور الحالية ما لم تحذفها. يمكنك أيضًا إضافة صور جديدة.",
      "updating": "جارٍ التحديث...",
      "update_listing": "تحديث الإعلان",
      "bathrooms_446": "الحمّامات",
      "unable_to_retrieve_this_rental_s_information": "تعذّر جلب معلومات هذا السكن.",
      "the_rental_has_been_updated": "تم تحديث إعلان الإيجار.",
      "unable_to_update_the_rental": "تعذّر تحديث إعلان الإيجار.",
      "unable_to_edit_this_rental": "تعذّر تعديل إعلان الإيجار",
      "edit_rental": "تعديل إعلان الإيجار",
      "edit_your_accommodation_amenities_details_and_photos": "عدّل سكنك وتجهيزاته ومعلوماته وصوره.",
      "accommodation_information": "معلومات السكن",
      "edit_the_main_details_of_your_vacation_rental": "عدّل المعلومات الأساسية لسكن العطلات.",
      "edit_the_accommodation_s_capacity_rates_and_additional_details": "عدّل سعة السكن وأسعاره ومعلوماته الإضافية.",
      "specify_the_amenities_available_to_guests": "حدّد التجهيزات المتوفرة للضيوف.",
      "accommodation_photos": "صور السكن",
      "keep_remove_or_add_photos_to_your_rental": "احتفظ بصور السكن أو احذفها أو أضف صورًا.",
      "keep_your_existing_photos_or_add_new_ones_to_showcase_your_accommodation": "احتفظ بصورك الحالية أو أضف صورًا جديدة لإبراز سكنك.",
      "update_rental": "تحديث إعلان الإيجار",
      "my_activity": "نشاطي",
      "sign_in_to_view_your_activity": "سجّل الدخول للاطّلاع على نشاطك.",
      "nothing_here_yet": "لا توجد عناصر حاليًا.",
      "clear_history": "مسح السجلّ",
      "search_again": "— إعادة البحث",
      "buy": "شراء",
      "houses_apartments": "منازل وشقق",
      "apartments_houses": "شقق ومنازل",
      "villas_residences": "فلل ومساكن",
      "offices": "مكاتب",
      "business_spaces": "مساحات مهنية",
      "shops": "محلّات تجارية",
      "premises_businesses": "محلّات وأصول تجارية",
      "land": "أراضٍ",
      "land_for_sale": "أراضٍ للبيع",
      "available_properties": "عقارات متاحة",
      "satisfied_customers": "عملاء راضون",
      "governorates_covered": "ولايات مشمولة",
      "average_rating": "متوسّط التقييم",
      "verified_listings": "إعلانات موثوقة",
      "all_listings_are_manually_reviewed": "تتم مراجعة جميع الإعلانات يدويًا.",
      "secure_payment": "دفع آمن",
      "your_transactions_are_protected_and_secure": "معاملاتك محميّة وآمنة.",
      "support_7_days_a_week": "دعم طوال الأسبوع",
      "our_team_is_available_to_help_you": "فريقنا متاح لمساعدتك.",
      "certified_agents": "وكلاء معتمدون",
      "real_estate_professionals_at_your_service": "متخصّصون في العقارات في خدمتك.",
      "i_found_my_apartment_in_just_two_days_fast_and_efficient_service": "وجدت شقّتي في يومين فقط. خدمة سريعة وفعّالة!",
      "the_site_is_very_easy_to_use_and_the_listings_are_high_quality": "الموقع سهل الاستخدام والإعلانات ذات جودة عالية.",
      "thanks_to_the_lina_immo_team_for_their_professionalism_and_attentiveness": "شكرًا لفريق Lina Immo على احترافيّته وحسن استماعه.",
      "unable_to_load_listings": "تعذّر تحميل الإعلانات.",
      "houses_for_sale_rentals_and_villas_in_tunisia_lina_immo": "منازل للبيع وعقارات للإيجار وفلل في تونس — Lina Immo",
      "explore_lina_immo_listings_houses_for_sale_apartments_for_rent_villas_land_and_vacation_rentals_in_t": "اكتشف إعلانات Lina Immo: منازل للبيع وشقق للإيجار وفلل وأراضٍ وإيجارات للعطلات في تونس.",
      "tunisia_real_estate_house_for_sale_apartment_for_rent_villa_for_sale_land_vacation_rental_tunis_sfax": "عقارات تونس، منزل للبيع، شقة للإيجار، فيلا للبيع، أرض، إيجار للعطلات، تونس، صفاقس، سوسة، الحمامات",
      "your_real_estate_partner_in_tunisia": "شريكك العقاري في تونس",
      "find_your_next_home": "اعثر على منزلك",
      "buy_rent_or_book_the_property_that_meets_your_needs_anywhere_in_tunisia": "اشترِ أو استأجر أو احجز العقار المناسب لاحتياجاتك في جميع أنحاء تونس.",
      "governorate": "الولاية",
      "all_governorates": "جميع الولايات",
      "all_districts": "جميع المعتمديات",
      "all_types": "جميع الأنواع",
      "apartment": "شقة",
      "house": "منزل",
      "villa": "فيلا",
      "office": "مكتب",
      "shop": "محلّ تجاري",
      "land_508": "أرض",
      "maximum_price": "السعر الأقصى",
      "all_budgets": "جميع الميزانيات",
      "searching": "جارٍ البحث...",
      "search": "بحث",
      "over_12_000_listings_available": "أكثر من 12,000 إعلان متاح",
      "explore_by_category": "تصفّح حسب الفئة",
      "why_choose_lina_immo": "لماذا تختار Lina Immo؟",
      "our_popular_cities": "المدن الأكثر طلبًا",
      "they_trust_us": "يثقون بنا",
      "mobile_app": "تطبيق الهاتف",
      "take_lina_immo_everywhere": "اصطحب Lina Immo أينما ذهبت",
      "find_your_favorite_listings_contact_owners_and_post_properties_from_your_phone": "تصفّح إعلاناتك المفضّلة وتواصل مع المالكين وانشر عقاراتك من هاتفك.",
      "available_on_google_play": "▶  قريبًا متاح على Google Play",
      "android_pending_validation":  "متاح قريبًا.",
      "ios_coming_soon": "متاح قريبًا.",
      "download_on_the_app_store": " تنزيل من App Store قريبًا",
      "stay_informed": "ابقَ على اطّلاع",
      "receive_new_listings_and_real_estate_offers_directly_by_email": "تلقَّ الإعلانات الجديدة والعروض العقارية مباشرة عبر البريد الإلكتروني.",
      "your_email_address": "عنوان بريدك الإلكتروني",
      "unable_to_load_this_listing": "تعذّر تحميل هذا الإعلان.",
      "please_complete_all_fields": "يرجى ملء جميع الحقول.",
      "unable_to_load_the_listing": "تعذّر تحميل الإعلان",
      "link_copied": "تم نسخ الرابط",
      "special_offer_530": "عرض خاص",
      "save": "وفّر",
      "no_parking": "بدون موقف سيارات",
      "unfurnished": "غير مفروش",
      "no_description_available": "لا يوجد وصف متاح.",
      "location": "الموقع",
      "open_in_maps": "فتح في الخرائط",
      "contact_the_owner": "اتصل بالمعلن",
      "get_more_information_or_arrange_a_viewing_of_this_property": "احصل على مزيد من المعلومات أو رتّب زيارة لهذا العقار.",
      "your_message_has_been_sent": "تم إرسال رسالتك.",
      "send_a_message": "إرسال رسالة",
      "your_name": "اسمك",
      "send_message": "إرسال الرسالة",
      "you_own_this_listing": "أنت مالك هذا الإعلان.",
      "no_photos_available": "لا توجد صور متاحة",
      "view": "عرض",
      "share_listing": "مشاركة الإعلان",
      "photo_gallery": "معرض الصور",
      "close_gallery": "إغلاق المعرض",
      "empty_message": "[رسالة فارغة]",
      "offers_found": "العروض المتوفّرة",
      "no_exact_matches": "لا توجد نتائج مطابقة تمامًا",
      "change_or_remove_some_filters_or_adjust_your_search_area": "عدّل بعض عوامل التصفية أو أزلها أو غيّر منطقة البحث.",
      "date": "التاريخ",
      "unable_to_sign_out": "تعذّر تسجيل الخروج.",
      "the_name_cannot_be_empty": "لا يمكن ترك الاسم فارغًا.",
      "profile_updated": "تم تحديث الملف الشخصي.",
      "unable_to_update_your_profile": "تعذّر تحديث ملفّك الشخصي.",
      "you_can_tell_us_why_you_are_leaving": "يمكنك إخبارنا بسبب مغادرتك.",
      "this_action_is_permanent_are_you_sure_you_want_to_delete_your_account": "هذا الإجراء نهائي. هل تريد بالتأكيد حذف حسابك؟",
      "your_account_has_been_deleted": "تم حذف حسابك.",
      "for_security_sign_in_again_before_deleting_your_account": "لدواعٍ أمنية، سجّل الدخول مجددًا قبل حذف حسابك.",
      "unable_to_delete_your_account": "تعذّر حذف حسابك.",
      "my_profile": "ملفّي الشخصي",
      "manage_your_personal_information_and_account_settings": "أدِر معلوماتك الشخصية وإعدادات حسابك.",
      "your_email_address_is_linked_to_your_sign_in_account": "يرتبط عنوان بريدك الإلكتروني بحساب تسجيل الدخول.",
      "save_567": "حفظ",
      "session": "حساب",
      "you_can_sign_out_of_your_account_at_any_time": "يمكنك تسجيل الخروج من حسابك في أي وقت.",
      "sign_out": "تسجيل الخروج",
      "danger_zone": "إجراءات حسّاسة",
      "deleting_your_account_is_permanent_and_cannot_be_undone": "حذف حسابك نهائي ولا يمكن التراجع عنه.",
      "delete_my_account": "حذف حسابي",
      "confirm_deletion": "تأكيد الحذف",
      "you_can_tell_us_why_you_want_to_delete_your_account": "يمكنك إخبارنا بسبب رغبتك في حذف حسابك.",
      "reason_for_deletion_optional": "سبب الحذف (اختياري)",
      "deleting": "جارٍ الحذف...",
      "delete_permanently": "حذف نهائي",
      "cancel_this_booking_request": "هل تريد إلغاء طلب الحجز هذا؟",
      "my_booking": "حجزي",
      "loading_581": "جارٍ التحميل…",
      "no_bookings_available": "لا توجد حجوزات متاحة.",
      "guests_583": "ضيوف ·",
      "accepted": "مقبول",
      "rejected_585": "مرفوض",
      "unknown_status": "حالة غير معروفة",
      "listing_deleted_587": "تم حذف الإعلان",
      "cancel_request": "إلغاء الطلب",
      "studio": "استوديو",
      "2_rooms": "غرفتان",
      "3_rooms": "3 غرف",
      "4_rooms": "4 غرف",
      "5_rooms": "5 غرف",
      "6_or_more_rooms": "6 غرف أو أكثر",
      "property_search": "البحث عن عقار",
      "select_a_city_then_refine_your_search_criteria": "اختر مدينة ثم حدّد معايير البحث.",
      "all_cities": "عرض جميع المدن",
      "category": "الفئة",
      "all_categories": "عرض جميع الفئات",
      "commercial": "تجاري",
      "other_601": "أخرى",
      "hide_filters": "إخفاء عوامل التصفية",
      "advanced_search": "بحث متقدّم",
      "keyword": "العنوان أو الموقع",
      "apartment_villa_land": "شقة، فيلا، أرض...",
      "number_of_rooms": "عدد الغرف",
      "minimum_price": "السعر الأدنى",
      "reset": "إعادة ضبط",
      "at_least_6_characters": "6 أحرف على الأقل",
      "passwords_do_not_match": "كلمتا المرور غير متطابقتين",
      "a_verification_email_has_been_sent_please_verify_your_email_before_continuing": "تم إرسال رسالة تأكيد. يرجى تأكيد بريدك الإلكتروني قبل المتابعة.",
      "email_verified": "تم تأكيد البريد الإلكتروني!",
      "invalid_email": "البريد الإلكتروني غير صالح",
      "email_already_in_use": "البريد الإلكتروني مستخدم بالفعل",
      "registration_failed": "تعذّر إنشاء الحساب",
      "illustration": "رسم توضيحي",
      "unable_to_load_vacation_rentals": "تعذّر تحميل إيجارات العطلات.",
      "find_your_vacation_rental": "اعثر على سكن لعطلتك",
      "discover_accommodation_across_tunisia_for_your_holidays_and_short_stays": "اكتشف مساكن في جميع أنحاء تونس لعطلاتك وإقاماتك القصيرة.",
      "title_or_location": "العنوان أو الموقع",
      "destination": "الوجهة",
      "number": "العدد",
      "available_stays": "إقامات متاحة",
      "rentals_in_city": "إيجارات في {{city}}",
      "all_rentals": "عرض جميع الإيجارات",
      "show_more": "عرض المزيد",
      "no_rentals_found": "لم يتم العثور على إيجارات",
      "change_your_destination_or_number_of_guests_to_find_more_accommodation": "غيّر الوجهة أو عدد الأشخاص للعثور على المزيد من المساكن.",
      "reset_filters": "إعادة ضبط",
      "sign_in_to_continue": "سجّل الدخول للمتابعة.",
      "your_session_has_changed_sign_in_again": "سجّل الدخول مجددًا.",
      "invalid_request_check_the_information_entered": "الطلب غير صالح. تحقّق من المعلومات .",
      "your_session_is_invalid_or_expired_sign_in_again": "جلستك غير صالحة أو منتهية. سجّل الدخول مجددًا.",
      "you_are_not_allowed_to_perform_this_action": "ليس لديك إذن لتنفيذ هذا الإجراء.",
      "this_resource_could_not_be_found_or_has_been_deleted": "هذا العنصر غير موجود أو تم حذفه.",
      "this_action_conflicts_with_the_current_data_refresh_and_try_again": "يتعارض هذا الإجراء مع البيانات الحالية. حدّث الصفحة وحاول مجددًا.",
      "this_listing_has_been_deleted": "تم حذف هذا الإعلان.",
      "api_url_not_allowed": "عنوان واجهة الخدمة غير مسموح به.",
      "unable_to_connect_check_your_connection_and_try_again": "تعذّر الاتصال. تحقّق من اتصالك وحاول مجددًا.",
      "add_photos_to_the_listing_form_before_saving": "أضف الصور إلى استمارة الإعلان قبل الحفظ.",
      "missing_listing_id": "معرّف الإعلان مفقود.",
      "this_listing_is_no_longer_available": "لم يعد هذا الإعلان متاحًا.",
      "you_do_not_own_this_listing_643": "أنت لست مالك هذا الإعلان.",
      "this_conversation_is_not_accessible": "لا يمكن الوصول إلى هذه المحادثة.",
      "invalid_recipient_or_message": "المستلم أو الرسالة غير صالحين.",
      "this_conversation_no_longer_accepts_new_messages": "لم تعد هذه المحادثة تقبل رسائل جديدة.",
      "unable_to_upload_files": "تعذّر رفع الملفات.",
      "invalid_listing": "الإعلان غير صالح.",
      "the_server_did_not_return_a_pdf": "لم يُرجع الخادم ملف PDF.",
      "invalid_date": "التاريخ غير صالح.",
      "choose_a_check_in_date_from_today_and_a_check_out_date_after_check_in": "اختر تاريخ وصول ابتداءً من اليوم وتاريخ مغادرة بعد الوصول.",
      "invalid_number_of_guests": "عدد الأشخاص غير صالح.",
      "a_request_is_already_in_progress": "طلبك الحالي قيد المعالجة. يُرجى الانتظار حتى اكتماله قبل إرسال طلب جديد.",
      "you_cannot_book_your_own_accommodation": "لا يمكنك الحجز.",
      "the_number_of_guests_exceeds_the_accommodation_s_capacity": "يتجاوز عدد الأشخاص سعة سكن.",
      "the_length_of_stay_discount_must_be_confirmed_before_booking_656": "يجب تأكيد تخفيض مدة الإقامة قبل الحجز.",
      "these_dates_are_no_longer_available": "لم تعد هذه التواريخ متاحة.",
      "this_booking_does_not_belong_to_you": "هذا ليس حجزك.",
      "only_a_pending_request_can_be_cancelled": "يمكن إلغاء الطلبات قيد الانتظار فقط.",
      "you_do_not_own_this_booking": "أنت لست مالك هذا الحجز.",
      "this_request_has_already_been_processed": "تمت معالجة هذا الطلب بالفعل.",
      "this_request_can_no_longer_be_accepted_the_account_or_listing_was_deleted": "لم يعد بالإمكان قبول هذا الطلب: تم حذف الحساب أو الإعلان.",
      "unable_to_load_properties": "تعذّر تحميل العقارات.",
      "server_unavailable": "الخادم غير متاح مؤقتًا. حاول مجددًا لاحقًا.",
      "select_departure": "اختر تاريخ المغادرة",
      "select_arrival": "اختر تاريخ الوصول",
      "google_sign_in": "تسجيل الدخول باستخدام Google",
      "newsletter_email_required": "أدخل عنوان بريدك الإلكتروني.",
      "newsletter_success": "شكرًا! تم تسجيل اشتراكك بنجاح.",
      "vacation_message": "مرحبًا، أودّ الحصول على مزيد من المعلومات حول هذا السكن.",
      "property_message": "مرحبًا، أنا مهتمّ بعقارك. هل لا يزال متاحًا؟",
      "pdf_failed": "تعذّر إنشاء ملف PDF.",
      "invalid_conversation": "بيانات المحادثة ناقصة أو غير صالحة.",
      "view_all": "عرض الكلّ",
      "loading_failed": "حدث خطأ أثناء التحميل.",
      "search_failed": "تعذّر إجراء البحث.",
      "featured_properties": "عقارات مميّزة",
      "view_listings": "عرض الإعلانات",
      "all_sales": "عرض جميع العقارات للبيع",
      "all_listings": "عرض جميع الإعلانات",
      "share_failed": "تعذّر مشاركة الرابط.",
      "all_properties": "جميع العقارات",
      "offers_only": "العروض فقط",
      "recently_viewed": "الإعلانات التي شاهدتها مؤخرًا",
      "listing_brand": "إعلان LinaImmo",
      "property_count": "عدد العقارات: {{count}}",
      "published_count": "عدد الإعلانات المنشورة: {{count}}",
      "image_number": "الصورة {{number}}",
      "listing_image": "{{title}} — الصورة {{number}}",
      "main_image": "{{title}} — الصورة الرئيسية",
      "view_listing_named": "عرض الإعلان {{title}}",
      "account_name": "حساب {{name}}",
      "increase": "زيادة {{label}}",
      "decrease": "تقليل {{label}}",
      "confirmed_total": "الإجمالي المؤكّد: {{total}} TND. ",
      "properties_in_city": "عقارات في {{city}}",
      "min_budget": "الحد الأدنى {{price}} TND",
      "max_budget": "الحد الأقصى {{price}} TND",
      "room_filter": "غرف النوم: {{rooms}}",
      "guest_filter": "الأشخاص: {{guests}}",
      "offers_city": "العروض المتوفّرة في {{city}}",
      "network_error_detail": "خطأ: {{message}}",
      "http_error": "خطأ HTTP: {{status}}",
      "photo_remove": "حذف الصورة",
      "previous_month": "الشهر السابق",
      "next_month": "الشهر التالي",
      "clear_date": "مسح التاريخ",
      "recent_search_history": "عمليات البحث الأخيرة",
      "photos_total": "عرض جميع الصور ({{count}})",
      "error_prefix": "خطأ:"
    },
    "remove_from_favorites": "إزالة من المفضلة",
    "add_to_favorites": "إضافة إلى المفضلة",
    "saving": "جارٍ الحفظ...",
    "in_my_favorites": "في المفضلة",
    "share": "مشاركة",
    "messages": "الرسائل",
    "preparing": "جارٍ التحضير...",
    "print": "طباعة",
    "profile": {
      "user_not_connected": "لم تسجّل الدخول.",
      "loading_error": "تعذّر تحميل إعلاناتك.",
      "confirm_delete": "هل تريد بالتأكيد حذف هذا الإعلان؟",
      "echec": "تعذّر الحذف",
      "succes": "تم الحذف بنجاح",
      "delete_error": "حدث خطأ أثناء الحذف.",
      "my_space": "مساحتي العقارية",
      "my_annonce": "إعلاناتي",
      "no_published_ads": "لم تنشر أي إعلان بعد.",
      "refresh": "تحديث",
      "empty_ads_description": "انشر أول إعلان لعقارك أو لإيجارك السياحي.",
      "vacation_ads": "إيجارات سياحية",
      "property_ads": "العقارات",
      "logout_error": "تعذّر تسجيل الخروج.",
      "name_required": "لا يمكن ترك الاسم فارغًا.",
      "no_changes": "لم يتم رصد تغييرات.",
      "final_delete_confirm": "هذا الإجراء نهائي. هل تريد بالتأكيد حذف حسابك؟",
      "recent_login_required": "لدواعٍ أمنية، سجّل الدخول مجددًا قبل حذف حسابك.",
      "description": "أدِر معلوماتك الشخصية وإعدادات حسابك.",
      "user": "مستخدم",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "email_notice": "يرتبط عنوان بريدك الإلكتروني بحساب تسجيل الدخول.",
      "saving": "جارٍ الحفظ...",
      "session": "الحساب",
      "session_description": "يمكنك تسجيل الخروج من حسابك في أي وقت.",
      "danger_zone": "إجراءات حسّاسة",
      "delete_description": "حذف حسابك نهائي ولا يمكن التراجع عنه.",
      "delete_confirm_title": "تأكيد الحذف",
      "delete_reason_text": "يمكنك إخبارنا بسبب رغبتك في حذف حسابك.",
      "deleting": "جارٍ الحذف...",
      "ads": "إعلانات",
      "ad": "إعلان",
      "published_ads": "إعلانات منشورة",
      "published_ad": "إعلان منشور"
    },
    "conversations": "المحادثات",
    "messages.search": "البحث في المحادثات",
    "messages.deleted_listing": "تم حذف الإعلان",
    "messages.property_discussion": "حول هذا الإعلان",
    "messages.open_discussion": "عرض الرسائل",
    "messages.delete_conversation": "حذف المحادثة",
    "messages.no_results": "لم يتم العثور على محادثات",
    "messages.discussion_note": "جميع محادثاتك في مكان واحد.",
    "create": {
      "address_search_required": "يرجى إدخال عنوان.",
      "address_not_found": "العنوان غير موجود.",
      "address_search_error": "تعذّر البحث عن هذا العنوان حاليًا.",
      "address_fields_required": "يرجى اختيار المدينة والمعتمدية.",
      "position_unconfirmed": "الموقع غير مؤكد",
      "area_position": "موقع تقريبي للمعتمدية وليس للعنوان الدقيق.",
      "search_address": "البحث عن العنوان",
      "map_preview": "معاينة الخريطة",
      "step_6": "الخطوة 6",
      "photos_title": "أضف صورك",
      "photos_description": "أضف صورًا واضحة ومضيئة لإبراز عقارك.",
      "upload_photos": "تحميل الصور",
      "upload_photos_help": "اختر صورة رئيسية ثم أضف صور الغرف والتجهيزات.",
      "photo_tips_title": "نصائح",
      "photo_tips": "استخدم صورًا أفقية واضحة وجيدة الإضاءة. تجنّب الصور الضبابية أو المظلمة.",
      "select_type_error": "اختر نوع المعاملة والعقار.",
      "title_required": "عنوان الإعلان مطلوب.",
      "surface_required": "أدخل مساحة صالحة.",
      "address_required": "أدخل عنوان العقار.",
      "price_required": "أدخل سعرًا صالحًا.",
      "discount_price_error": "يجب أن يكون السعر المخفّض أقل من السعر الأصلي.",
      "contact_required": "أدخل بريدك الإلكتروني ورقم هاتفك.",
      "login_required": "يجب تسجيل الدخول لنشر إعلان.",
      "images_required": "أضف صورة واحدة على الأقل.",
      "success": "تم نشر إعلانك بنجاح.",
      "error": "تعذّر نشر الإعلان.",
      "description": "أدخل معلومات عقارك في بضع خطوات.",
      "transaction_title": "ما نوع الإعلان الذي تريد نشره؟",
      "transaction_description": "اختر نوع المعاملة والعقار.",
      "describe_title": "صِف عقارك",
      "describe_description": "أضف عنوانًا واضحًا والخصائص الأساسية.",
      "address_title": "حدّد موقع عقارك",
      "address_description": "أدخل العنوان الدقيق ليتمكّن المشترون من تحديد موقع عقارك بسهولة.",
      "price_title": "حدّد السعر",
      "price_description": "أدخل سعر العقار وأضف تخفيضًا إن أردت.",
      "discount_price": "السعر بعد التخفيض",
      "contact_title": "بيانات الاتصال الخاصة بك",
      "contact_description": "تتيح هذه البيانات للمهتمّين التواصل معك.",
      "publish": "نشر الإعلان"
    },
    "SelectDelegation": "اختر معتمدية",
    "Continuer": "متابعة",
    "vacation": {
      "accommodation": "إيجار سياحي",
      "no_listings": "لا توجد إيجارات للعطلات متاحة حاليًا.",
      "category_required": "اختر نوع السكن.",
      "address_required": "يرجى إدخال العنوان والمدينة والمعتمدية.",
      "guests_required": "يجب أن يتّسع السكن لشخص واحد على الأقل.",
      "price_required": "أدخل سعرًا صالحًا.",
      "discount_error": "يجب أن يكون السعر المخفّض أقل من السعر العادي.",
      "contact_required": "أدخل بريدك الإلكتروني ورقم هاتفك.",
      "login_required": "يجب تسجيل الدخول لنشر إعلان.",
      "photos_required": "أضف صورة واحدة على الأقل.",
      "create_success": "تم نشر إعلان إيجار العطلات.",
      "create_error": "تعذّر نشر إعلانك.",
      "create_title": "نشر إعلان إيجار سياحي",
      "create_description": "قدّم سكنك وتجهيزاته وأسعاره في بضع خطوات.",
      "accommodation_title": "ما نوع السكن الذي تقدّمه؟",
      "accommodation_description": "اختر الصيغة المناسبة لسكنك.",
      "equipment_description": "اختر التجهيزات المتوفرة في سكنك.",
      "address_title": "حدّد موقع السكن",
      "address_description": "أدخل العنوان وتحقّق من الموقع على الخريطة.",
      "capacity_description": "أدخل عدد الأشخاص وغرف النوم والأسرّة والحمامات.",
      "pricing_title": "حدّد أسعارك",
      "pricing_description": "أدخل السعر اليومي والتخفيضات المتاحة.",
      "discount_price": "السعر بعد التخفيض",
      "contact_description": "تتيح هذه البيانات للضيوف التواصل معك.",
      "photos_title": "أضف صور السكن",
      "photos_description": "اختر صورًا مضيئة تُظهر الغرف والتجهيزات.",
      "publish": "نشر إعلان الإيجار",
      "search_description": "اكتشف مساكن في جميع أنحاء تونس لعطلاتك وإقاماتك القصيرة.",
      "guests_placeholder": "العدد",
      "available_stays": "إقامات متاحة",
      "results_in_city": "إيجارات في {{city}}",
      "all_results": "جميع الإيجارات",
      "results": "نتائج",
      "result": "نتيجة"
    },
    "close": "إغلاق",
    "messages.view_conversations": "عرض المحادثات",
    "messages.title": "الرسائل",
    "messages.start": "تبدأ محادثتك هنا",
    "messages.start_hint": "اطرح سؤالك الأول حول هذا الإعلان.",
    "messages.deleted_notice": "تم حذف هذا الإعلان. لا يزال بإمكانك الاطلاع على رسائلك.",
    "messages.recipient_unavailable": "لم يعد هذا المستلم متاحًا. لا يزال بإمكانك الاطلاع على رسائلك.",
    "messages.keyboard_hint": "Enter للإرسال · Shift + Enter لسطر جديد",
    "messages.waiting_for_reply": "في انتظار الرد: يمكنك الكتابة مجددًا بمجرد أن يرد محاورك.",
    "messages.limit_consecutive": "لقد أرسلت عدة رسائل دون رد. انتظر رد محاورك قبل الكتابة مجددًا.",
    "messages.limit_new_conversations": "لقد فتحت العديد من المحادثات الجديدة اليوم. لا يزال بإمكانك الرد في محادثاتك؛ أعد المحاولة لاحقًا لفتح محادثة جديدة.",
    "loading": "جارٍ التحميل...",
    "request": {
      "load_error": "تعذّر تحميل الطلبات.",
      "invalid_id": "معرّف الطلب غير صالح.",
      "update_error": "تعذّر تحديث الطلب.",
      "description": "اطّلع على الطلبات الواردة واقبل الحجوزات أو ارفضها.",
      "empty_description": "ليس لديك طلبات حجز لمعالجتها حاليًا."
    },
    "cancelled": "ملغاة",
    "request_accepted": "تم قبول الطلب.",
    "request_cancelled": "تم رفض الطلب.",
    "refresh": "تحديث",
    "accept": "قبول",
    "reject": "رفض",
    "reservation": {
      "load_error": "تعذّر تحميل حجوزاتك.",
      "description": "اطّلع على جميع طلبات الحجز وأدِرها.",
      "empty_description": "ليس لديك حجوزات لعرضها حاليًا."
    },
    "confirm": "هل تريد بالتأكيد إلغاء هذا الحجز؟",
    "success": "تم إلغاء الحجز.",
    "failed": "تعذّر إلغاء الحجز.",
    "booking_date": "حجز",
    "messages.load_error": "تعذّر تحميل محادثاتك.",
    "messages.conversation_error": "تعذّر تحميل هذه المحادثة.",
    "messages.send_error": "تعذّر إرسال الرسالة.",
    "messages.delete_confirm": "هل تريد حذف هذه المحادثة؟",
    "messages.delete_error": "تعذّر حذف هذه المحادثة.",
    "messages.login_required": "يلزم تسجيل الدخول",
    "messages.login_description": "سجّل الدخول للاطّلاع على محادثاتك.",
    "messages.empty_description": "ستظهر هنا محادثاتك مع المالكين والمستخدمين.",
    "messages.select_conversation": "اختر محادثة",
    "messages.select_description": "اختر محادثة لعرض رسائلها.",
    "description": "الوصف",
    "rooms.bedrooms": "غرف النوم",
    "sending": "جارٍ الإرسال...",
    "details": "سعة السكن",
    "edit.invalid_id": "معرّف الإعلان غير صالح.",
    "edit.not_found": "لم يتم العثور على هذا الإعلان.",
    "edit.load_error": "تعذّر جلب معلومات هذا الإعلان.",
    "edit.no_changes": "لم يتم رصد تغييرات.",
    "edit.success": "تم تحديث الإعلان.",
    "edit.update_error": "تعذّر تحديث الإعلان.",
    "edit.error_title": "تعذّر تعديل الإعلان",
    "edit.back_ads": "العودة إلى إعلاناتي",
    "edit.description": "عدّل معلومات إعلانك ثم احفظ التغييرات.",
    "edit.unsaved_changes": "تغييرات غير محفوظة",
    "edit.step": "الخطوة {{number}}",
    "edit.property_title": "معلومات العقار",
    "edit.property_description": "عدّل المعلومات الأساسية لإعلانك.",
    "edit.additional_title": "معلومات إضافية",
    "edit.additional_description": "أكمل خصائص العقار ومعلوماته الإضافية.",
    "edit.photos_title": "صور الإعلان",
    "edit.photos_description": "احتفظ بصور إعلانك أو احذفها أو أضف صورًا.",
    "edit.manage_photos": "إدارة الصور",
    "edit.manage_photos_description": "تُحفظ الصور الحالية ما لم تحذفها. يمكنك أيضًا إضافة صور جديدة.",
    "edit.updating": "جارٍ التحديث...",
    "editVacation": {
      "load_error": "تعذّر جلب معلومات هذا السكن.",
      "success": "تم تحديث إعلان الإيجار.",
      "update_error": "تعذّر تحديث إعلان الإيجار.",
      "error_title": "تعذّر تعديل إعلان الإيجار",
      "description": "عدّل سكنك وتجهيزاته ومعلوماته وصوره.",
      "property_title": "معلومات السكن",
      "property_description": "عدّل المعلومات الأساسية لسكن العطلات.",
      "additional_title": "معلومات إضافية",
      "additional_description": "عدّل سعة السكن وأسعاره ومعلوماته الإضافية.",
      "options_title": "التجهيزات والخدمات",
      "options_description": "حدّد التجهيزات المتوفرة للضيوف.",
      "photos_title": "صور السكن",
      "photos_description": "احتفظ بصور السكن أو احذفها أو أضف صورًا.",
      "manage_photos_description": "احتفظ بصورك الحالية أو أضف صورًا جديدة لإبراز سكنك."
    },
    "rooms.studio": "استوديو",
    "rooms.two": "غرفتان",
    "rooms.three": "3 غرف",
    "rooms.four": "4 غرف",
    "rooms.five": "5 غرف",
    "rooms.six_or_more": "6 غرف أو أكثر",
    "errorFetchingVacations": "تعذّر تحميل إيجارات العطلات.",
    "confirmation_password": "تأكيد كلمة المرور",
    "you_have": "لديك",
    "pending_notifications": "إشعارات قيد الانتظار",
    "contacts": "بيانات الاتصال",
    "Coût": "التكلفة",
    "cost": "التكلفة",
    "name": "الاسم",
    "describe_property": "صِف عقارك",
    "upload_images": "أضف صورًا",
    "locate_property": "حدّد موقع عقارك",
    "localize_property": "حدّد موقع عقارك",
    "select_city": "اختر مدينة",
    "select_delegation": "اختر معتمدية",
    "login": "تسجيل الدخول",
    "signup": "إنشاء حساب",
    "categories": {
      "apartment": "شقة",
      "house": "منزل",
      "commercial": "تجاري",
      "land": "أرض",
      "others": "أخرى"
    },
    "appartement": "شقة",
    "maison": "منزل",
    "terrain": "أرض",
    "autres": "أخرى",
    "sale": "بيع"
  }
};
